import React, 
       { useState, 
         useEffect, 
         useRef, 
         useCallback }                      from "react";
import { useNavigate   }                    from "react-router-dom";
import { useLoader}                         from "components/Covers/loadingCover";
import { useActionModal}                    from "components/Covers/confirmAction";
import { useInfoMsgModal}                   from "components/Covers/infoMessageModal";
import { useToastMessage}                   from "components/Covers/toastMessage";
import { InputGeneral}                      from "components/Field/field";
import { DatePicker,
         DateTimePicker,
         DateToIsoString,
         DateFromIsoString,
         InitDateToIsoString,
         InitDateFromIsoString,
         setDefaultInitDate,
         setDefaultFinalDate,
         setDefaultOrderInitDate,
         compareInitFinDate,
         DisplayGridDatetime,
         getDateInPortuguese,
         getDateInEnglish,
         getDateInSpanish, 
         FinDateFromIsoString,
         FinDateToIsoString}                 from "components/Date/date";
import { BtnCloseAction}                    from "components/Buttons/Close/BtnClose";
import  MainStyle                           from "components/UI/main.module.scss";
import { getOrdersList,
         getOrderByID,
         getOrderMeta,
         updateOrder,
         deleteOrder,
         updateOrderStatus,
         updateOrderNotification,
         copyOrder,
         regenFiles,
         getParamOrdersList,
         getOrderSearchData,
         closeOrderByID }                   from "./orderManagementService";
// BEGIN AG AGRID
import {AgGridReact}                        from "ag-grid-react";
import {AllCommunityModule,ModuleRegistry}  from 'ag-grid-community';
import {AG_GRID_LOCALE_BR}                  from '@ag-grid-community/locale';
import { Select }                           from "antd";

/*  Drag and drops libs  */
import { DndProvider, useDrag, useDrop }    from 'react-dnd';
import { HTML5Backend }                     from 'react-dnd-html5-backend';
import { TouchBackend }                     from 'react-dnd-touch-backend';

import { q3x_FunData, 
         getImgSrc, 
         getFileTmpSrc,
         DefaultLoadingLogo,
         q3x_CustomFunData,
         DavidCopperfield,
         Heimdall,
         GetLabel,
         GetAppLang,
         SetLastFeature,
         toSafeFilename  }                  from "Utilities/utils";

import {useFilter}                          from "components/Menu/menu";

import dayjs                                from "dayjs";

// #region Object Template
let blank_order_obj = {
    ORDER_ID               :    0           ,
    STATUS_ID              :    3           ,
    SCHOOL_ID              :    0           ,
    AREA_ID                :    0           ,
    CLIENT_ID              :    0           ,
    PROGRAM_ID             :    0           ,
    COLOR                  :    0           ,
    QRCODE                 :    0           ,
    QRCODE_DATA            :    ""          ,
    QRCODEP                :    0           ,
    QRCODEP_DATA           :    ""          ,
    PPT_TEMPLATE           :    0           ,
    PPT                    :    0           ,
    PPT_DATA               :    ""          ,
    PPT_FOOTER             :    0           ,
    LOGO1                  :    0           ,
    LOGO2                  :    0           ,
    LOGO3                  :    0           ,
    ORDER_CODE             :    ""          ,
    ORDER_DESC             :    ""          ,
    CLASS                  :    ""          ,
    OPENING                :    DateToIsoString(setDefaultOrderInitDate()),  
    CLOSING                :    DateToIsoString(dayjs().add(7,'day').set('hour', 23).set('minute', 59).set('second', 59)), 
    LANG_PT                :    "Y"         , 
    LANG_EN                :    "N"         , 
    LANG_ES                :    "N"         , 
    OBSERVATIONS           :    "N"         , 
    HEADER_LANG_PT_DESC_1  :    "Avaliação de Qualidade",
    HEADER_LANG_PT_DESC_2  :    "Programa",
    HEADER_LANG_PT_DESC_3  :    ""          ,
    HEADER_LANG_PT_DESC_4  :    `São Paulo, XX de ${getDateInPortuguese().month} de ${getDateInPortuguese().year}`,
    HEADER_LANG_EN_DESC_1  :    "Quality Assessment",
    HEADER_LANG_EN_DESC_2  :    "Program",
    HEADER_LANG_EN_DESC_3  :    ""          ,
    HEADER_LANG_EN_DESC_4  :    `São Paulo, ${getDateInEnglish().month} XXth ${getDateInEnglish().year}`,
    HEADER_LANG_ES_DESC_1  :    "Evaluación de Calidad",
    HEADER_LANG_ES_DESC_2  :    "Programa",
    HEADER_LANG_ES_DESC_3  :    ""          ,
    HEADER_LANG_ES_DESC_4  :    `São Paulo, XX de ${getDateInSpanish().month} de ${getDateInSpanish().year}`,
    EXPLAN_LANG            :    "Y", 
    EXPLAN_LANG_PT_DESC    :    "A sua avaliação é muito importante para melhorarmos continuamente os programas que oferecemos.|n|Agradecemos o seu esforço.|n|Por favor, avalie cada um dos seguintes aspectos e faça seus comentários - sugestões no espaço apropriado.",
    EXPLAN_LANG_EN_DESC    :    "Your evaluation is very important for the continuous improvement of the programs we offer.|n|We appreciate your effort.|n|Please rate each of the following aspects and provide your comments - suggestions in the appropriate space.",
    EXPLAN_LANG_ES_DESC    :    "Su evaluación es muy importante para mejorar continuamente los programas que ofrecemos.|n|Agradecemos su esfuerzo.|n|Por favor, califique cada uno de los siguientes aspectos y escriba sus comentarios - sugerencias en el espacio correspondiente.",
    SUBTI_LANG             :    "Y", 
    SUBTI_LANG_PT_DESC     :    "Estrelas:|n|1 = Baixo - Negativo - Discordo - Insatisfatório|n|5 = Alto - Positivo - Concordo - Excelente",
    SUBTI_LANG_EN_DESC     :    "Stars:|n|1 = Low - Negative - Disagree - Unsatisfactory|n|5 = High - Positive - Agree - Excellent",
    SUBTI_LANG_ES_DESC     :    "Estrellas:|n|1 = Bajo - Negativo - En desacuerdo - Insatisfactorio|n|5 = Alto - Positivo - De acuerdo - Excelente",
    SESSIONS               :    []          , 
    USERS                  :    []          ,
    RESPONSIBLES           :    []          ,
    CLASSES                :    []      
};
let blank_session_obj = {
    ORDER_ID                : 0,
    SESSION_ORDER           : 0,
    SESSION_DESC            : "",
    ACADEMIC_AREA_ID        : 0,
    COURSE_ID               : null,
    EXTERNAL_COURSE_ID      : null,
    DEPARTMENT_ID           : null,
    EXTERNAL_DEPARTMENT_ID  : null,
    SESSION_LINES           : [],
    SESSION_QUESTIONS       : [],
    IsEditing               : true
};
let blank_session_line_obj = {
    ORDER_ID         : 0   ,
    SESSION_ORDER    : 0   ,
    TYPE_ID          : 0   ,
    LINE_ORDER       : 0   ,
    DESIGNATION_ID   : 0   ,
    USER_ID          : 0   ,
    STUDY_CASE_ID    : 0   , 
    LBL_BOLD         : "Y" ,
    LBL_LANG_PT_DESC : "Caso",
    LBL_LANG_EN_DESC : "Case",
    LBL_LANG_ES_DESC : "Caso",
    TXT_BOLD         : "N" ,
    TXT_LANG_PT_DESC : ""  ,
    TXT_LANG_EN_DESC : ""  ,
    TXT_LANG_ES_DESC : ""             
};
let blank_user_obj = {
    USER_ID   : 0 ,
    FULL_NAME : "",
    FILE_ID   : 0 ,
    FILE_DATA : ""
};
let blank_search_param_obj = {
    STATUS_ID:          [3],
    DT_INIT:            null,
    DT_FN:              null,
    SCHOOL_ID:          null,
    AREA_ID:            null,
    CLIENT_ID:          null,
    PROGRAM_ID:         null
}
let blank_order_pattern_question_obj = {
    ORDER_ID: 0,
    SESSION_ORDER: 0,
    PATTERN_TEMPLATE: 0,
    QUESTION_ID: 0,
    QUESTION_POSITION: 0,
    MANDATORY: "N",
    BOLD: "N",
    PREFIX: "",
};

let blank_classes_obj = {
	CLASS_ID: 0,
    CLASS_DESC: "",
};

let appLang = null;

// #endregion

// #region Layout Helppers
const DropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
    mode
  }) => {
    return (
      <Select
        showSearch
        allowClear
        mode={mode}
        id={id}
        name={name}
        value={value} // use directly from props
        placeholder={placeholder}
        className={className}
        style={style}
        title={title}
        popupClassName={popupClassName}
        options={listOfItems}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={(val, option) => {
          onChange?.(val, option); // lift change to parent
        }}
        onSearch={(val) => {
          onSearch?.(val);
        }}
        notFoundContent={null}
      />
    );
};
const DefaultPadding = () =>{
    return(<div className={MainStyle.py_3}/>);
};
const DivisionBlock = () => {
    return(
        <>
            <div className={[MainStyle.py_2].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={[MainStyle.col_lg, MainStyle.border_bottom].join(" ")}/>
                </div>
            </div>
        </>
    );
};
const Avatar = () => {
    return (
        <svg viewBox="0 -5 66 66" xmlns="http://www.w3.org/2000/svg" style={{ backgroundColor: '#f0f0f0', width: '100%', height: '100%'}}>
            <circle className={MainStyle.avatar_head} cx="32" cy="22" r="12" fill="#707070"/>
            <path d="M32 36c-9 0-20 6-20 14v14h40V50c0-8-11-14-20-14z" fill="#707070"/>
            <ellipse className={MainStyle.avatar_eye_left} cx="27" cy="20" rx="2" ry="2" fill="#fff"/>
            <ellipse className={MainStyle.avatar_eye_right} cx="37" cy="20" rx="2" ry="2" fill="#fff"/>
        </svg>
    );
};
const Landscape = () => {
    const [var0, setVar0] = useState(280);
    const [var1, setVar1] = useState(330);
    
    const direction0 = useRef(1); // 1 = up, -1 = down
    const direction1 = useRef(1);
    
    useEffect(() => {
      let frameId;
      const animate = () => {
        setVar0(prev => {
          let next = prev + direction0.current;
          if (next >= 330 || next <= 280) direction0.current *= -1;
          return next;
        });
  
        setVar1(prev => {
          let next = prev + direction1.current;
          if (next >= 380 || next <= 330) direction1.current *= -1;
          return next;
        });
  
        frameId = requestAnimationFrame(animate);
      };
  
      frameId = requestAnimationFrame(animate);
  
      return () => cancelAnimationFrame(frameId);
    }, []);
  
    return (
      <svg viewBox="0 0 800 400" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: 'auto' }}>
        <rect x="0" y="0" width="800" height="400" rx="15" fill="#f0f0f0" />
        <rect x="23" y="26" width="754" height="347" fill="#ffe0ab" />
        <rect x="23" y="26" width="754" height="110" fill="#87CEEB" />
        <circle cx="150" cy="80" r="50" fill="#FFE484" className={MainStyle.sun_logo_svg_image}/>
        <path className={MainStyle.cloud_logo_svg_image} d="M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"/>
        <path
          d="M23,135 C23 135, 777 135, 777 135 C777 135, 500 180, 580 180 C580 180, 700 200, 550 300 C550 300, 450 360, 300,371 L300 373, 23,373 Z"
          style={{ fill: '#30b1ce' }}
        />
        <path
          d={`
            M25,300
            C25 300,  400 ${var0}, 550 200
          `}
          style={{
            stroke: '#fff',
            strokeWidth: '3',
            fill: 'none',
          }}
        />
        <path
          d={`
            M25,350
            C25 350,  400 ${var1}, 580 225
          `}
          style={{
            stroke: '#fff',
            strokeWidth: '6',
            fill: 'none',
          }}
        />
      </svg>
    );
};
/*
const getDndBackend = () => {
    const isTouchDevice =
      typeof window !== 'undefined' &&
      ('ontouchstart' in window || navigator.maxTouchPoints > 0);
  
    return {
      backend: isTouchDevice ? TouchBackend : HTML5Backend,
      options: isTouchDevice ? { enableMouseEvents: true } : undefined,
    };
};
*/
const GetDndBackend = () => {
    const [backendInfo, setBackendInfo] = useState({
      backend: HTML5Backend,
      options: undefined,
    });
  
    useEffect(() => {
      const isTouchDevice =
        typeof window !== 'undefined' &&
        (('ontouchstart' in window) || (navigator.maxTouchPoints ?? 0) > 0);
  
      setBackendInfo({
        backend: isTouchDevice ? TouchBackend : HTML5Backend,
        options: isTouchDevice ? { enableMouseEvents: true } : undefined,
      });
    }, []);
  
    return backendInfo;
  };
//#endregion

const CloseObj  = ({handleExit}) => {
    return (
        <>
            <div className={MainStyle.mt_3}/>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_1}>                            
                </div>
                <div className={MainStyle.col_11}>
                    <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                        {<BtnCloseAction click_action={handleExit}/>}
                    </div>
                </div>
            </div>
            <div className={MainStyle.mt_3}/>
        </>
    );

};

function stateManager({ setObjectState, objectValue }) {
    setObjectState(objectValue);
}

// #region Tab 0
const SelectUserResponsiblePopup = React.memo(({displayModal, setDisplayModal, objectSet, mainDataset, dataset}) => {     
    const { showToastMessage            } = useToastMessage();   // Toast message display
    const [searchString, setSearchString] = useState("");
    const [filteredData, setFilteredData] = useState(dataset);

    const handleSelect = (user_id, full_name, position_desc, sector_desc, file_data) => {
        if (mainDataset.RESPONSIBLES.some((u) => u.USER_ID === user_id)) {
            showToastMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 218)});
            return;
        }
        const newObject = {
            ...blank_user_obj,
            USER_ID:   user_id,
            FULL_NAME: full_name,
            COMPANY_POSITION_DESC: position_desc,
            SECTOR_DESC: sector_desc,
            FILE_DATA: file_data,
        };
        const newList = [...mainDataset.RESPONSIBLES, newObject]
        objectSet({ RESPONSIBLES: newList });
        setDisplayModal(false);
    };
    const handleSearchData = (event) => {
        setSearchString(event);
        let temp_arr = dataset.filter((item) =>
            item.FULL_NAME.toLowerCase().includes(event.toLowerCase())
        );
        setFilteredData(temp_arr);
    };
    useEffect(() => {
        setFilteredData(dataset);

    }, [dataset]);
    
    return (
        <>
        {displayModal == true ?
            <div className={[MainStyle.modal].join(" ")}>
              <div className={[MainStyle.modal_dialog].join(" ")}>
                <div className={[MainStyle.modal_content, MainStyle.rounded_3, MainStyle.shadow_sm, MainStyle.border, MainStyle.bg_card, MainStyle.mx_3].join(" ")}>
                  <div className={MainStyle.m_3}>
                    <div className={MainStyle.modal_header}>
                      <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_4, MainStyle.fw_semibold].join(" ")}>
                        {GetLabel(appLang, 219)}
                      </span>
                    </div>
                    <div className={MainStyle.modal_body}>
                        <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_12}>
                                    <InputGeneral 
                                        value={searchString}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => handleSearchData(event.target.value)}
                                        placeholder={GetLabel(appLang, 33)}
                                        maxLength={500}
                                    />
                                </div>
                        </div>



                        <div className={[MainStyle.overflow_y_scroll].join(" ")} style={{height: '20rem'}}>

                        
                        {  filteredData !== dataset ?
                            
                            filteredData?.length == 0 ?
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg_12}>
                                        <p className={[  MainStyle.fs_7,
                                                         MainStyle.text_body_faded,
                                                         MainStyle.fw_semibold,
                                                         MainStyle.mt_3,
                                                         MainStyle.text_center
                                                        ].join(" ")}
                                        >
                                            {GetLabel(appLang, 220)}
                                        </p>
                                    </div>
                                </div>
                            :
                            filteredData?.map((data) => {
                                return (
                                    <div key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom, MainStyle.clickable].join(" ")}
                                         onClick={() => handleSelect(data.USER_ID, 
                                                                     data.FULL_NAME, 
                                                                     data.COMPANY_POSITION_DESC,
                                                                     data.SECTOR_DESC,
                                                                     data.FILE_DATA)}
                                         alt={data.FULL_NAME}
                                    >
                                            <div className={MainStyle.col_12}>
                                                <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                    <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                         className={[MainStyle.border,
                                                                     MainStyle.shadow, 
                                                                     MainStyle.rounded_circle,
                                                                     MainStyle.my_2].join(" ")}
                                                    >
                                                        {
                                                            data.FILE_DATA != null ?
                                                                <img  src={getImgSrc(data.FILE_DATA)} 
                                                                      style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                                />
                                                            :
                                                                <Avatar/>
                                                        }
                                                    </div>
                                                    <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3, MainStyle.mx_3].join(" ")}>
                                                        {data.FULL_NAME} ({data.COMPANY_POSITION_DESC}) {GetLabel(appLang, 44)} {data.SECTOR_DESC}
                                                    </p>
                                                </div>
                                            </div>
                                    </div>
                                );
                            })
                        :
                            dataset?.length > 0 ?                             
                            dataset?.map((data) => {
                                return (
                                    <div key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom, MainStyle.clickable].join(" ")}
                                        onClick={() => handleSelect(data.USER_ID, 
                                                                    data.FULL_NAME, 
                                                                    data.COMPANY_POSITION_DESC,
                                                                    data.SECTOR_DESC,
                                                                    data.FILE_DATA)}
                                         alt={data.FULL_NAME}
                                    >
                                            <div className={MainStyle.col_12}>
                                                <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                    <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                         className={[MainStyle.border,
                                                                     MainStyle.shadow, 
                                                                     MainStyle.rounded_circle,
                                                                     MainStyle.my_2].join(" ")}
                                                    >
                                                        {
                                                            data.FILE_DATA != null ?
                                                                <img  src={getImgSrc(data.FILE_DATA)} 
                                                                      style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                                />
                                                            :
                                                                <Avatar/>
                                                        }
                                                    </div>
                                                    <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3, MainStyle.text_start, MainStyle.mx_3].join(" ")}>
                                                        {data.FULL_NAME} ({data.COMPANY_POSITION_DESC}) {GetLabel(appLang, 44)} {data.SECTOR_DESC}
                                                    </p>
                                                </div>
                                            </div>
                                    </div>
                                );
                            })
                            :
                            null
                        }
                        </div>
                    </div>
                    <div className={MainStyle.my_3}></div>
                    <div className={MainStyle.row}>
                      <div className={MainStyle.col_lg_7}></div>
                      <div className={MainStyle.col_lg_2}></div>
                      <div className={MainStyle.col_lg_1}></div>
                      <div className={MainStyle.col_lg_2}>
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                              style={{width: '100%'}}
                              className={[MainStyle.btn_blue, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow_sm, MainStyle.fs_6, MainStyle.text_white, MainStyle.py_3, MainStyle.px_3].join(" ")}
                              onClick={() => setDisplayModal(false)}
                            >
                              {GetLabel(appLang, 53)}
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        :
        null
        }
        </>
    );

});
const SelectUserAccessPopup = React.memo(({displayModal, setDisplayModal, objectSet, mainDataset, dataset}) => {     
    const { showToastMessage            } = useToastMessage();   // Toast message display
    const [searchString, setSearchString] = useState("");
    const [filteredData, setFilteredData] = useState(dataset);

    const handleSelect = (user_id, full_name, position_desc, sector_desc, file_data) => {
        if (mainDataset.USERS.some((u) => u.USER_ID === user_id)) {
            showToastMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 218)});
            return;
        }
        const newObject = {
            ...blank_user_obj,
            USER_ID:   user_id,
            FULL_NAME: full_name,
            COMPANY_POSITION_DESC: position_desc,
            SECTOR_DESC: sector_desc,
            FILE_DATA: file_data,
        };
        const newList = [...mainDataset.USERS, newObject]
        objectSet({ USERS: newList });
        setDisplayModal(false);
    };
    const handleSearchData = (event) => {
        setSearchString(event);
        let temp_arr = dataset.filter((item) =>
            item.FULL_NAME.toLowerCase().includes(event.toLowerCase())
        );
        setFilteredData(temp_arr);
    };
    useEffect(() => {
        setFilteredData(dataset);

    }, [dataset]);
    
    return (
        <>
        {displayModal == true ?
            <div className={[MainStyle.modal].join(" ")}>
              <div className={[MainStyle.modal_dialog].join(" ")}>
                <div className={[MainStyle.modal_content, MainStyle.rounded_3, MainStyle.shadow_sm, MainStyle.border, MainStyle.bg_card, MainStyle.mx_3].join(" ")}>
                  <div className={MainStyle.m_3}>
                    <div className={MainStyle.modal_header}>
                      <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_4, MainStyle.fw_semibold].join(" ")}>
                        {GetLabel(appLang, 219)}
                      </span>
                    </div>
                    <div className={MainStyle.modal_body}>
                        <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_12}>
                                    <InputGeneral 
                                        value={searchString}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => handleSearchData(event.target.value)}
                                        placeholder={GetLabel(appLang, 33)}
                                        maxLength={500}
                                    />
                                </div>
                        </div>



                        <div className={[MainStyle.overflow_y_scroll].join(" ")} style={{height: '20rem'}}>

                        
                        {  filteredData !== dataset ?
                            
                            filteredData?.length == 0 ?
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg_12}>
                                        <p className={[  MainStyle.fs_7,
                                                         MainStyle.text_body_faded,
                                                         MainStyle.fw_semibold,
                                                         MainStyle.mt_3,
                                                         MainStyle.text_center
                                                        ].join(" ")}
                                        >
                                            {GetLabel(appLang, 220)}
                                        </p>
                                    </div>
                                </div>
                            :
                            filteredData?.map((data) => {
                                return (
                                    <div key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom, MainStyle.clickable].join(" ")}
                                         onClick={() => handleSelect(data.USER_ID, 
                                                                     data.FULL_NAME, 
                                                                     data.COMPANY_POSITION_DESC,
                                                                     data.SECTOR_DESC,
                                                                     data.FILE_DATA)}
                                         alt={data.FULL_NAME}
                                    >
                                            <div className={MainStyle.col_12}>
                                                <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                    <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                         className={[MainStyle.border,
                                                                     MainStyle.shadow, 
                                                                     MainStyle.rounded_circle,
                                                                     MainStyle.my_2].join(" ")}
                                                    >
                                                        {
                                                            data.FILE_DATA != null ?
                                                                <img  src={getImgSrc(data.FILE_DATA)} 
                                                                      style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                                />
                                                            :
                                                                <Avatar/>
                                                        }
                                                    </div>
                                                    <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3, MainStyle.mx_3].join(" ")}>
                                                        {data.FULL_NAME} ({data.COMPANY_POSITION_DESC}) {GetLabel(appLang, 44)} {data.SECTOR_DESC}
                                                    </p>
                                                </div>
                                            </div>
                                    </div>
                                );
                            })
                        :
                            dataset?.length > 0 ?                             
                            dataset?.map((data) => {
                                return (
                                    <div key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom, MainStyle.clickable].join(" ")}
                                        onClick={() => handleSelect(data.USER_ID, 
                                                                    data.FULL_NAME, 
                                                                    data.COMPANY_POSITION_DESC,
                                                                    data.SECTOR_DESC,
                                                                    data.FILE_DATA)}
                                         alt={data.FULL_NAME}
                                    >
                                            <div className={MainStyle.col_12}>
                                                <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                    <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                         className={[MainStyle.border,
                                                                     MainStyle.shadow, 
                                                                     MainStyle.rounded_circle,
                                                                     MainStyle.my_2].join(" ")}
                                                    >
                                                        {
                                                            data.FILE_DATA != null ?
                                                                <img  src={getImgSrc(data.FILE_DATA)} 
                                                                      style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                                />
                                                            :
                                                                <Avatar/>
                                                        }
                                                    </div>
                                                    <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3, MainStyle.text_start, MainStyle.mx_3].join(" ")}>
                                                        {data.FULL_NAME} ({data.COMPANY_POSITION_DESC}) {GetLabel(appLang, 44)} {data.SECTOR_DESC}
                                                    </p>
                                                </div>
                                            </div>
                                    </div>
                                );
                            })
                            :
                            null
                        }
                        </div>
                    </div>
                    <div className={MainStyle.my_3}></div>
                    <div className={MainStyle.row}>
                      <div className={MainStyle.col_lg_7}></div>
                      <div className={MainStyle.col_lg_2}></div>
                      <div className={MainStyle.col_lg_1}></div>
                      <div className={MainStyle.col_lg_2}>
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                              style={{width: '100%'}}
                              className={[MainStyle.btn_blue, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow_sm, MainStyle.fs_6, MainStyle.text_white, MainStyle.py_3, MainStyle.px_3].join(" ")}
                              onClick={() => setDisplayModal(false)}
                            >
                              {GetLabel(appLang, 53)}
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        :
        null
        }
        </>
    );

});
const UserIsResponsible = React.memo(({objectSet, dataset}) => {
    const handleDelete = (user_id) => {
        const newList = dataset.filter(user => user.USER_ID !== user_id);
        objectSet({ RESPONSIBLES: newList });
    };

    useEffect(() => {
    }, [ dataset ]);
    
    return (
        <>
            <div className={dataset.length > 0 ? MainStyle.overflow_y_scroll : null}
                 style={dataset.length > 0 ? {height: '20rem'}: null}
            >
                {
                    dataset.map((data) => {
                        return (
                            <div  key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom].join(" ")}>
                                    <div className={MainStyle.col_1}/>
                                    <div className={MainStyle.col_10}>
                                        <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                            <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                className={[MainStyle.border,
                                                            MainStyle.shadow, 
                                                            MainStyle.rounded_circle,
                                                            MainStyle.my_2].join(" ")}
                                            >
                                                {   
                                                    data.FILE_DATA != null ?
                                                        <img 
                                                            src={getImgSrc(data.FILE_DATA)} 
                                                            style={{width: '100%', height: '100%', objectFit:'cover', objectPosition: 'center'}}
                                                        />
                                                    :
                                                        <Avatar/>
                                                }
                                            </div>
                                            <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3].join(" ")}>
                                            {data.FULL_NAME} ({data.COMPANY_POSITION_DESC}) {GetLabel(appLang, 44)} {data.SECTOR_DESC}
                                            </p>
                                            <div 
                                                className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1].join(" ")}
                                                onClick={() => {handleDelete(data.USER_ID)}}                                                 
                                            >
                                                <svg 
                                                    xmlns="http://www.w3.org/2000/svg" 
                                                    viewBox="0 0 448 512"
                                                    className={[MainStyle.small_ico_generic].join(" ")}
                                                >
                                                    <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={MainStyle.col_1}/>
                            </div>
                        );
                    })
                }                        
            </div>
        </>
    );

});
const UserHasAccess = React.memo(({objectSet, dataset}) => {
    const handleDelete = (user_id) => {
        const newList = dataset.filter(user => user.USER_ID !== user_id);
        objectSet({ USERS: newList });
    };

    useEffect(() => {
    }, [ dataset ]);
    
    return (
        <>
            <div className={dataset.length > 0 ? MainStyle.overflow_y_scroll : null}
                 style={dataset.length > 0 ? {height: '20rem'}: null}
            >
                {
                    dataset.map((data) => {
                        return (
                            <div  key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom].join(" ")}>
                                    <div className={MainStyle.col_1}/>
                                    <div className={MainStyle.col_10}>
                                        <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                            <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                className={[MainStyle.border,
                                                            MainStyle.shadow, 
                                                            MainStyle.rounded_circle,
                                                            MainStyle.my_2].join(" ")}
                                            >
                                                {   
                                                    data.FILE_DATA != null ?
                                                        <img 
                                                            src={getImgSrc(data.FILE_DATA)} 
                                                            style={{width: '100%', height: '100%', objectFit:'cover', objectPosition: 'center'}}
                                                        />
                                                    :
                                                        <Avatar/>
                                                }
                                            </div>
                                            <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3].join(" ")}>
                                            {data.FULL_NAME} ({data.COMPANY_POSITION_DESC}) {GetLabel(appLang, 44)} {data.SECTOR_DESC}
                                            </p>
                                            <div 
                                                className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1].join(" ")}
                                                onClick={() => {handleDelete(data.USER_ID)}}                                                 
                                            >
                                                <svg 
                                                    xmlns="http://www.w3.org/2000/svg" 
                                                    viewBox="0 0 448 512"
                                                    className={[MainStyle.small_ico_generic].join(" ")}
                                                >
                                                    <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={MainStyle.col_1}/>
                            </div>
                        );
                    })
                }                        
            </div>
        </>
    );

});
const Tab_0_Block_0 = React.memo(({prop, setProp, metaProp}) => {
    const { showInfoMessage }  = useInfoMsgModal();  // Modal message control
    const { showActionMessage } = useActionModal();


    function toggleLang(lang) {
        const field = `LANG_${lang}`;
        const value = prop[field] === "Y" ? "N" : "Y";
    
        stateManager({
            setObjectState: setProp,
            objectValue: {
                [field]: value
            }
        });
    }
    function patternLangValidation(toggledLang) {
        if (!metaProp?.ORDER_SETTINGS?.PATTERNS) return true;
    
        const futureLangs = ['PT', 'EN', 'ES'].filter(lang => {
            if (lang === toggledLang) {
                return prop[`LANG_${lang}`] !== 'Y';
            }
            return prop[`LANG_${lang}`] === 'Y';
        });
    
        for (const session of prop.SESSIONS) {
            if (session.PATTERN_ID === 0) continue;
    
            const pattern = metaProp.ORDER_SETTINGS.PATTERNS.find(
                p => p.PATTERN_ID === session.PATTERN_ID
            );
    
            if (!pattern) continue;
    
            const hasMissingLang = pattern.QUESTIONS.some(q =>
                futureLangs.some(lang => q[`LANG_${lang}`] !== 'Y')
            );
    
            if (hasMissingLang) return false;
        }
    
        return true;
    }
    function handleDependencies(toggledLang) {
        try {
            const futureLangs = ['PT', 'EN', 'ES'].filter(lang => {
                if (lang === toggledLang) {
                    return prop[`LANG_${lang}`] !== 'Y';
                }
                return prop[`LANG_${lang}`] === 'Y';
            });

            const updatedSessions = prop.SESSIONS.map((session) => {
                if (session.PATTERN_ID === 0) return session;

                const pattern = metaProp.ORDER_SETTINGS.PATTERNS.find(
                    p => p.PATTERN_ID === session.PATTERN_ID
                );

                const hasMissingLang = pattern.QUESTIONS.some(q =>
                    futureLangs.some(lang => q[`LANG_${lang}`] !== 'Y')
                );

                if (hasMissingLang) {
                    return { ...session, PATTERN_ID: undefined };
                }

                return session;
            });

            stateManager({
                setObjectState: setProp,
                objectValue: {
                    ["SESSIONS"]: updatedSessions
                }
            });
        } catch (e) {
            console.warn("Error to update the state trace: " + e);
        }
    }
    function handleLangChange(lang) {
        let canChange = patternLangValidation(lang);
        if (canChange) {
            toggleLang(lang);
        }
        else {
            showActionMessage(
                { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 372)}<br/>{GetLabel(appLang, 373)}</> },
                { confirm_action: () => {handleDependencies(lang);toggleLang(lang);}}
            );
            return;
        }
    }

    return (
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg_8}>
                <div className={MainStyle.mx_2}>
                    <span className={[MainStyle.fs_6, MainStyle.fw_semibold, MainStyle.text_body].join(" ")}>{GetLabel(appLang, 374)}*</span>
                    <InputGeneral 
                        value={prop.ORDER_DESC || ''}
                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2].join(" ")} 
                        onChange={(event) => { 
                                stateManager({
                                    setObjectState: setProp,
                                    objectValue: {
                                        ORDER_DESC: q3x_FunData(event.target.value)
                                    }
                                });
                            }
                        }
                        placeholder={GetLabel(appLang, 375)}
                        maxLength={200}
                        autoSize={true}
                    />
                    <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.ORDER_DESC?.length} {GetLabel(appLang, 44)} 200 {GetLabel(appLang, 45)}.</span>
                </div>
            </div>
            <div className={MainStyle.col_lg_1}>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.mx_3, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 204)}</span>
                </div>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3].join(" ")}>
                    <input
                        type="checkbox"
                        name={"read"}
                        checked={prop.LANG_PT === "Y" ? true : false}
                        onChange={()=> {handleLangChange("PT")}}
                        style={{ transform: "scale(1.5)" }}
                        disabled={false}
                    />
                </div>
            </div>
            <div className={MainStyle.col_lg_1}>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.mx_3, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 205)}</span>
                </div>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3].join(" ")}>
                    <input
                        type="checkbox"
                        name={"read"}
                        checked={prop.LANG_EN === "Y" ? true : false}
                        onChange={()=> {handleLangChange("EN")}}
                        style={{ transform: "scale(1.5)" }}
                        disabled={false}
                    />
                </div>
            </div>
            <div className={MainStyle.col_lg_1}>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.mx_3, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 206)}</span>
                </div>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3].join(" ")}>
                    <input
                        type="checkbox"
                        name={"read"}
                        checked={prop.LANG_ES === "Y" ? true : false}
                        onChange={()=> {handleLangChange("ES")}}
                        style={{ transform: "scale(1.5)" }}
                        disabled={false}
                    />
                </div>
            </div>
            <div className={MainStyle.col_lg_1}>
                <div className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.justify_content_center].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.mx_1, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 376)}</span>
                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon].join(" ")} onClick={() => {showInfoMessage({header: GetLabel(appLang, 199), message: <>{GetLabel(appLang, 377)}<br/>{GetLabel(appLang, 378)}</>});}}>
                        <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                            <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                        </svg>
                    </div>
                </div>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3].join(" ")}>
                    <input
                        type="checkbox"
                        name={"read"}
                        checked={prop.OBSERVATIONS === "Y" ? true : false}
                        onChange={()=> {
                                prop.OBSERVATIONS === "Y" ?  
                                    stateManager({
                                        setObjectState: setProp,
                                        objectValue: {
                                            OBSERVATIONS : "N"
                                        }
                                    })
                                : 
                                    stateManager({
                                        setObjectState: setProp,
                                        objectValue: {
                                            OBSERVATIONS: "Y"
                                        }
                                    })
                        }}
                        style={{ transform: "scale(1.5)" }}
                        disabled={false}
                    />
                </div>
            </div>
        </div>
    );
});
const Tab_0_Block_1 = React.memo(({prop, setProp, metaProp}) => {
    const [areaList,    setAreaList]    = useState([]);
    const [programList, setProgramList] = useState([]);

    function handleSchoolChange(school_id) {
        stateManager({
            setObjectState: setProp,
            objectValue: {
                SCHOOL_ID: parseInt(school_id),
                AREA_ID: 0,
                PROGRAM_ID: 0,
                CLASSES: []
            }
        });
        metaProp.ORDER_META.map((item) => {
            if (prop.SCHOOL_ID === item.SCHOOL_ID) {
                setAreaList(item.AREAS);
                setProgramList([]);
            }  
        });
    }
    function handleAreaChange(area_id) {
        stateManager({
            setObjectState: setProp,
            objectValue: {
                AREA_ID: parseInt(area_id),
                PROGRAM_ID: 0,
                CLASSES: []
            }
        });
    
        if (area_id != 0) {
            const selectedArea = areaList.find(item => item.AREA_ID === parseInt(area_id));
            setProgramList(selectedArea?.PROGRAMS || []);
        }
    }

    useEffect(() =>{
        if ((metaProp != null || metaProp != undefined) && metaProp?.ORDER_META?.length > 0)  {
            if (prop.SCHOOL_ID != 0){
                metaProp.ORDER_META.map((item) => {
                    if (prop.SCHOOL_ID === item.SCHOOL_ID) {
                        setAreaList(item.AREAS);
                    }  
                });
            }
            if (prop.AREA_ID !== 0) {
                for (let i = 0; i < areaList.length; i++) {
                    if (prop.AREA_ID === areaList[i].AREA_ID) {
                        setProgramList(areaList[i].PROGRAMS || []);
                        break;
                    }
                }
            }
            
        }
    }, [prop, setProp, metaProp, areaList, programList]);
    
    return (
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 318)}*</span>
                    {metaProp?.ORDER_META && (
                        <DropdownList
                            value={prop.SCHOOL_ID > 0 ? parseInt(prop.SCHOOL_ID) : undefined}
                            placeholder={GetLabel(appLang, 379)}
                            listOfItems={ 
                                metaProp?.ORDER_META.map((i) => (
                                        {value: i.SCHOOL_ID, label: i.SCHOOL_DESC}
                                    ))
                            }
                            style={{ width: "100%" }}
                            className={[MainStyle.mt_2].join(" ")}
                            onChange={(event) => {handleSchoolChange(event);}}
                        />
                    )}
                </div>
            </div>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 319)}*</span>
                    {metaProp?.ORDER_META && (
                        <DropdownList
                            value={prop.AREA_ID > 0 ? parseInt(prop.AREA_ID) : undefined}
                            placeholder={GetLabel(appLang, 380)}
                            listOfItems={ 
                                areaList?.map((i) => (
                                        {value: i.AREA_ID, label: i.AREA_DESC}
                                    ))
                            }
                            style={{ width: "100%" }}
                            className={[MainStyle.mt_2].join(" ")}
                            onChange={(event) => {
                                handleAreaChange(event);
                            }}
                        />
                    )}
                </div>
            </div>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 321)}*</span>
                    {metaProp?.ORDER_META && (
                        <DropdownList
                            value={prop.PROGRAM_ID > 0 ? parseInt(prop.PROGRAM_ID) : undefined}
                            placeholder={GetLabel(appLang, 381)}
                            listOfItems={ 
                                programList?.map((i) => (
                                        {value: i.PROGRAM_ID, label: i.PROGRAM_DESC}
                                    ))
                            }
                            style={{ width: "100%" }}
                            className={[MainStyle.mt_2].join(" ")}
                            onChange={(event) => {
                                stateManager({
                                    setObjectState: setProp,
                                    objectValue: {
                                        PROGRAM_ID: event,
                                        CLASSES: []
                                    }
                                });
                            }}
                        />
                    )}
                </div>
            </div>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                    <span className={[MainStyle.fs_6, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 661)}</span>

                    <DropdownList
                        mode="multiple"
                        value={prop.CLASSES || []}
                        placeholder={GetLabel(appLang, 666)}
                        listOfItems={
                            metaProp?.CLASSES
                            ?.filter((i) =>
                                parseInt(i.PROGRAM_ID) === parseInt(prop.PROGRAM_ID))
                           .map((i) => ({
                                value: i.CLASS_ID,
                                label: i.CLASS_DESC
                            }))
                        }
                        style={{ width: "100%" }}
                        className={[MainStyle.mt_2].join(" ")}
                        onChange={(event) => {
                            stateManager({
                                setObjectState: setProp,
                                objectValue: {
                                    CLASSES: event
                                }
                            });
                        }}
                    />
                </div>
            </div>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 322)}*</span>
                    {metaProp?.ORDER_META && (
                        <DropdownList
                            value={prop.CLIENT_ID > 0 ? parseInt(prop.CLIENT_ID) : undefined}
                            placeholder={GetLabel(appLang, 382)}
                            listOfItems={ 
                                metaProp?.CLIENTS?.map((i) => (
                                        {value: i.CLIENT_ID, label: i.CLIENT_DESC}
                                    ))
                            }
                            style={{ width: "100%" }}
                            className={[MainStyle.mt_2].join(" ")}
                            onChange={(event) => {
                                stateManager({
                                    setObjectState: setProp,
                                    objectValue: {
                                        CLIENT_ID: event
                                    }
                                });
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
});
const Tab_0_Block_2 = React.memo(({prop, setProp, metaProp}) => {
    useEffect(() =>{
    }, [prop, setProp, metaProp]);
    
    return (
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 383)}*</span>
                    <InputGeneral 
                        value={prop.CLASS || ''}
                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2].join(" ")} 
                        onChange={(event) => { 
                                stateManager({
                                    setObjectState: setProp,
                                    objectValue: {
                                        CLASS: q3x_FunData(event.target.value)
                                    }
                                });
                            }
                        }
                        placeholder={GetLabel(appLang, 384)}
                        maxLength={200}
                        autoSize={true}
                    />
                    <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.CLASS?.length} {GetLabel(appLang, 44)} 200 {GetLabel(appLang, 45)}.</span>
                </div>
            </div>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 385)}*</span>
                    <DropdownList
                        value={prop.PPT_TEMPLATE > 0 ? parseInt(prop.PPT_TEMPLATE) : undefined}
                        placeholder={GetLabel(appLang, 385)}
                        listOfItems={ 
                            metaProp?.ORDER_SETTINGS?.PPT_TEMPLATE.map((i) => (
                                    {value: i.FILE_ID, label: i.FILE_DESC}
                                ))
                        }
                        style={{ width: "100%" }}
                        className={[MainStyle.mt_2].join(" ")}
                        onChange={(event) => {
                            stateManager({
                                setObjectState: setProp,
                                objectValue: {PPT_TEMPLATE: event}
                            });
                        }}
                    />
                </div>
            </div>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 386)}*</span>
                    <DropdownList
                        value={prop.PPT_FOOTER > 0 ? parseInt(prop.PPT_FOOTER) : undefined}
                        placeholder={GetLabel(appLang, 386)}
                        listOfItems={ 
                            metaProp?.ORDER_SETTINGS?.PPT_FOOTER.map((i) => (
                                    {value: i.FILE_ID, label: i.FILE_DESC}
                                ))
                        }
                        style={{ width: "100%" }}
                        className={[MainStyle.mt_2].join(" ")}
                        onChange={(event) => {
                            stateManager({
                                setObjectState: setProp,
                                objectValue: {PPT_FOOTER: event}
                            });
                        }}
                    />
                </div>
            </div>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 387)}*</span>
                    <DropdownList
                        value={prop.COLOR > 0 ? parseInt(prop.COLOR) : undefined}
                        placeholder={GetLabel(appLang, 387)}
                        listOfItems={ 
                            metaProp?.ORDER_SETTINGS?.COLORS.map((i) => (
                                    {value: i.FILE_ID, label: i.FILE_DESC}
                                ))
                        }
                        style={{ width: "100%" }}
                        className={[MainStyle.mt_2].join(" ")}
                        onChange={(event) => {
                            stateManager({
                                setObjectState: setProp,
                                objectValue: {COLOR: event}
                            });
                        }}
                    />
                </div>
            </div>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 388)}*:</span>
                    <DateTimePicker
                        value={DateFromIsoString(prop.OPENING)}
                        placeholder={GetLabel(appLang, 388)}
                        style={{ width: "100%" }}
                        className={[MainStyle.mt_2].join(" ")}
                        onChange={(date) => {
                            stateManager({
                                setObjectState: setProp,
                                objectValue: {OPENING: DateToIsoString(date)}
                            });
                        }}
                    />
                </div>
            </div>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 389)} *:</span>
                    <DateTimePicker
                        value={DateFromIsoString(prop.CLOSING)}
                        placeholder={GetLabel(appLang, 389)}
                        style={{ width: "100%" }}
                        className={[MainStyle.mt_2].join(" ")}
                        onChange={(date) => {
                            stateManager({
                                setObjectState: setProp,
                                objectValue: {CLOSING: DateToIsoString(date)}
                            });
                        }}                       
                    />
                </div>
            </div>
        </div>
    );
});
const Tab_0_Block_3 = React.memo(({prop, setProp, metaProp}) => {
    const [ displayModal,     setDisplayModal         ]  = useState(false);

    useEffect(() =>{
    }, [prop, setProp, metaProp]);
    
    return (
        <>
        <SelectUserResponsiblePopup 
            displayModal={displayModal} 
            setDisplayModal={setDisplayModal}
            mainDataset={prop}
            objectSet={setProp}
            dataset={metaProp?.ORDER_SETTINGS?.USERS}
            
        />
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg_2}>
                <div className={[MainStyle.mx_2, MainStyle.mt_2].join(" ")}>
                    <button
                        style={{width: '100%'}}
                        className={[MainStyle.btn_blue, 
                                    MainStyle.rounded_3, 
                                    MainStyle.border, 
                                    MainStyle.shadow_sm, 
                                    MainStyle.fs_7,
                                    MainStyle.text_white,
                                    MainStyle.py_3,
                                    MainStyle.px_3].join(" ")}
                        onClick={() => {setDisplayModal(true);}}
                    >
                        {GetLabel(appLang, 390)}
                    </button>
                </div>
            </div>
            <div className={MainStyle.col_lg_10}>
                <div className={[MainStyle.mx_2, MainStyle.mt_2].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body].join(" ")}>{GetLabel(appLang, 391)}:</span>
                    {
                        prop?.RESPONSIBLES?.length > 0 ?
                            <UserIsResponsible objectSet={setProp} dataset={prop.RESPONSIBLES}/>
                        :
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                <span className={[MainStyle.fs_8,MainStyle.text_body_faded, MainStyle.mt_3].join(" ")}>{GetLabel(appLang, 392)}</span>
                            </div>

                    }
                </div>
            </div>
        </div>
        </>
    );
});
const Tab_0_Block_4 = React.memo(({prop}) => {
    const [expanded, setExpanded] = useState(false);
    return (
        <>        
            { 
                expanded ?
                    <>
                        <div className={[MainStyle.bg_card_item, MainStyle.shadow_sm, MainStyle.border, MainStyle.rounded].join(" ")}>
                            <div className={[MainStyle.row, MainStyle.bg_header_item, MainStyle.rounded_top_1].join(" ")}>
                                <div className={MainStyle.col}>
                                    <div className={[MainStyle.d_flex, MainStyle.justify_content_end].join(" ")}>
                                        <div className={MainStyle.align_items_center}>
                                            <span className={[MainStyle.m_2, MainStyle.text_white, MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 393)}
                                            </span>
                                        </div>
                                        <div 
                                            onClick={() => {setExpanded(false);}}
                                            className={[MainStyle.shadow_sm, MainStyle.rounded_top_1, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                                <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_9}></div>
                                <div className={MainStyle.col_lg}>
                                    <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                                        <div className={MainStyle.text_center}>
                                            <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>
                                              {GetLabel(appLang, 394)}
                                            </span>
                                            <img 
                                                src={getFileTmpSrc(prop.QRCODE_DATA)} 
                                                style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                className={[MainStyle.border_bottom, MainStyle.border_end, MainStyle.shadow_sm].join(" ")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.col_lg_1}></div>
                                <div className={MainStyle.col_lg}>
                                    <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                                        <div className={MainStyle.text_center}>
                                            <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>
                                              {GetLabel(appLang, 395)}
                                            </span>
                                            <img 
                                                src={getFileTmpSrc(prop.QRCODEP_DATA)} 
                                                style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                className={[MainStyle.border_bottom, MainStyle.border_end, MainStyle.shadow_sm].join(" ")}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                :
                    <>
                        <div className={[MainStyle.bg_card_item, MainStyle.shadow_sm, MainStyle.border, MainStyle.rounded].join(" ")}>
                            <div className={[MainStyle.row, MainStyle.bg_header_item, MainStyle.rounded_top_end_bottom_end_1].join(" ")}>
                                <div className={MainStyle.col}>
                                    <div className={MainStyle.text_center}></div>
                                    <div className={[MainStyle.d_flex, MainStyle.justify_content_end].join(" ")}>
                                        <div className={MainStyle.align_items_center}>
                                            <span className={[MainStyle.m_2, MainStyle.text_white, MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 393)}
                                            </span>
                                        </div>
                                        <div 
                                            onClick={() => {setExpanded(true);}}
                                            className={[MainStyle.shadow_sm, MainStyle.rounded_top_end_bottom_end_1, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                                <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }
        </>
    );

});
const Tab_0_Block_5 = React.memo(({prop, setProp, metaProp}) => {
    const [ displayModal,     setDisplayModal         ]  = useState(false);

    useEffect(() =>{
    }, [prop, setProp, metaProp]);
    
    return (
        <>
        <SelectUserAccessPopup 
            displayModal={displayModal} 
            setDisplayModal={setDisplayModal}
            mainDataset={prop}
            objectSet={setProp}
            dataset={metaProp?.ORDER_SETTINGS?.USERS}
            
        />
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg_2}>
                <div className={[MainStyle.mx_2, MainStyle.mt_2].join(" ")}>
                    <button
                        style={{width: '100%'}}
                        className={[MainStyle.btn_blue, 
                                    MainStyle.rounded_3, 
                                    MainStyle.border, 
                                    MainStyle.shadow_sm, 
                                    MainStyle.fs_7,
                                    MainStyle.text_white,
                                    MainStyle.py_3,
                                    MainStyle.px_3].join(" ")}
                        onClick={() => {setDisplayModal(true);}}
                    >
                        {GetLabel(appLang, 396)}
                    </button>
                </div>
            </div>
            <div className={MainStyle.col_lg_10}>
                <div className={[MainStyle.mx_2, MainStyle.mt_2].join(" ")}>
                    <span className={[MainStyle.fs_6,MainStyle.text_body].join(" ")}>{GetLabel(appLang, 397)}:</span>
                    {
                        prop?.USERS?.length > 0 ?
                            <UserHasAccess objectSet={setProp} dataset={prop.USERS}/>
                        :
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                <span className={[MainStyle.fs_8,MainStyle.text_body_faded, MainStyle.mt_3].join(" ")}>{GetLabel(appLang, 392)}</span>
                            </div>

                    }
                </div>
            </div>
        </div>
        </>
    );
});

const Tab_0 = React.memo(({...other}) => {
    const {prop, setProp, orderMeta} = other;
    return (
        <>
            {prop.ORDER_ID != 0 && (
                <><Tab_0_Block_4 prop={prop}/>
                    <DefaultPadding/>
                </>
            )}
            <Tab_0_Block_0 prop={prop} setProp={setProp} metaProp={orderMeta}/>
                <DefaultPadding/>
                <DivisionBlock/>
                <DefaultPadding/>
            <Tab_0_Block_1 prop={prop} setProp={setProp} metaProp={orderMeta}/>
                <DefaultPadding/>
                <DivisionBlock/>
                <DefaultPadding/>
            <Tab_0_Block_2 prop={prop} setProp={setProp} metaProp={orderMeta}/>
                <DefaultPadding/>
                <DivisionBlock/>
                <DefaultPadding/>
            <Tab_0_Block_3 prop={prop} setProp={setProp} metaProp={orderMeta}/>
                <DefaultPadding/>
            <Tab_0_Block_5 prop={prop} setProp={setProp} metaProp={orderMeta}/>
                <DefaultPadding/>

        </>
    );

});
// #endregion

// #region Tab 1
const SelectLogoPopup = React.memo(({displayModal, setDisplayModal, objectSet, dataset, ...other}) => {
    const [searchString, setSearchString] = useState("");
    const [filteredData, setFilteredData] = useState(dataset);
    const { compID }                      = other;
    const handleSelect = (file_id, file_data) => {
        if (compID == 0 ) {
            objectSet({ LOGO1: file_id, LOGO1_DATA: file_data});
        }
        else if (compID == 1 ) {
            objectSet({ LOGO2: file_id, LOGO2_DATA: file_data});
        }
        else {
            objectSet({ LOGO3: file_id, LOGO3_DATA: file_data});
        }
        setDisplayModal(false);
    };
    const handleSearchData = (event) => {
        setSearchString(event);
        let temp_arr = dataset.filter((item) =>
            item.FILE_DESC.toLowerCase().includes(event.toLowerCase())
        );
        setFilteredData(temp_arr);
    };
    return (
        <>
        {displayModal == true ?
            <div className={[MainStyle.modal].join(" ")}>
              <div className={[MainStyle.modal_dialog].join(" ")}>
                <div className={[MainStyle.modal_content, MainStyle.rounded_3, MainStyle.shadow_sm, MainStyle.border, MainStyle.bg_card, MainStyle.mx_3].join(" ")}>
                  <div className={MainStyle.m_3}>
                    <div className={MainStyle.modal_header}>
                      <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_4, MainStyle.fw_semibold].join(" ")}>
                        {GetLabel(appLang, 398)}
                      </span>
                    </div>
                    <div className={MainStyle.modal_body}>
                        <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_12}>
                                    <InputGeneral 
                                        value={searchString}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => handleSearchData(event.target.value)}
                                        placeholder={GetLabel(appLang, 33)}
                                        maxLength={500}
                                    />
                                </div>
                        </div>



                        <div className={MainStyle.overflow_y_scroll} style={{height: '20rem'}}>

                        
                        {  filteredData !== dataset ?
                            
                            filteredData?.length == 0 ?
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg_12}>
                                        <p className={[  MainStyle.fs_7,
                                                         MainStyle.text_body_faded,
                                                         MainStyle.fw_semibold,
                                                         MainStyle.mt_3,
                                                         MainStyle.text_center
                                                        ].join(" ")}
                                        >
                                            {GetLabel(appLang, 220)}
                                        </p>
                                    </div>
                                </div>
                            :
                            filteredData?.map((data) => {
                                return (
                                    <div  key={data.FILE_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom, MainStyle.clickable].join(" ")}
                                         onClick={() => handleSelect(data.FILE_ID, data.FILE_DATA)}
                                         alt={data.FILE_DESC}
                                    >
                                            <div className={MainStyle.col_lg_11}>
                                                <div className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                    <div style={{overflowX: 'hidden',
                                                         overflowY: 'hidden',
                                                         width: '5rem', 
                                                         height: '5rem'}}
                                                         className={[MainStyle.border,
                                                                     MainStyle.shadow,
                                                                     MainStyle.my_2].join(" ")}
                                                    >
                                                        <img 
                                                            src={getImgSrc(data.FILE_DATA)} 
                                                            style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                        />
                                                    </div>
                                                    <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3].join(" ")}>{data.FILE_DESC}</p>
                                                </div>
                                            </div>
                                            <div className={MainStyle.col_lg_1}/>
                                    </div>
                                );
                            })
                        :
                            dataset?.length > 0 ?                             
                            dataset?.map((data) => {
                                return (
                                    <div  key={data.FILE_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom, MainStyle.clickable].join(" ")}
                                         onClick={() => handleSelect(data.FILE_ID, data.FILE_DATA)}
                                         alt={data.FILE_DESC}
                                    >
                                            <div className={MainStyle.col_lg_11}>
                                                <div className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                    <div style={{overflowX: 'hidden',
                                                         overflowY: 'hidden',
                                                         width: '5rem', 
                                                         height: '5rem'}}
                                                         className={[MainStyle.border,
                                                                     MainStyle.shadow,
                                                                     MainStyle.my_2].join(" ")}
                                                    >
                                                        <img 
                                                            src={getImgSrc(data.FILE_DATA)} 
                                                            style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                        />
                                                    </div>
                                                    <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3].join(" ")}>{data.FILE_DESC}</p>
                                                </div>
                                            </div>
                                            <div className={MainStyle.col_lg_1}/>
                                    </div>
                                );
                            })
                            :
                            null
                        }
                        </div>
                    </div>
                    <div className={MainStyle.my_3}></div>
                    <div className={MainStyle.row}>
                      <div className={MainStyle.col_lg_7}></div>
                      <div className={MainStyle.col_lg_2}></div>
                      <div className={MainStyle.col_lg_1}></div>
                      <div className={MainStyle.col_lg_2}>
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                              style={{width: '100%'}}
                              className={[MainStyle.btn_blue, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow_sm, MainStyle.fs_6, MainStyle.text_white, MainStyle.py_3, MainStyle.px_3].join(" ")}
                              onClick={() => setDisplayModal(false)}
                            >
                              {GetLabel(appLang, 53)}
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        :
        null
        }
        </>
    );

});
const Tab_1_Block_0 = React.memo(({prop, setProp}) => {
    useEffect(() =>{
    }, [prop, setProp]);

    return (
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg}>
                <div className={MainStyle.mx_2}>
                    {
                        prop.LANG_PT == "Y" && 
                            (<>
                                <p className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 399)}</p>
                                <InputGeneral 
                                    value={prop.HEADER_LANG_PT_DESC_1 || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2, MainStyle.text_wrap].join(" ")}
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    HEADER_LANG_PT_DESC_1: q3x_FunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 400)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.HEADER_LANG_PT_DESC_1?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                                <InputGeneral 
                                    value={prop.HEADER_LANG_PT_DESC_2 || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2, MainStyle.text_wrap].join(" ")}
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    HEADER_LANG_PT_DESC_2: q3x_FunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 400)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.HEADER_LANG_PT_DESC_2?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                                <InputGeneral 
                                    value={prop.HEADER_LANG_PT_DESC_3 || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2, MainStyle.text_wrap].join(" ")}
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    HEADER_LANG_PT_DESC_3: q3x_FunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 400)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.HEADER_LANG_PT_DESC_3?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                                <InputGeneral 
                                    value={prop.HEADER_LANG_PT_DESC_4 || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2, MainStyle.text_wrap].join(" ")}
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    HEADER_LANG_PT_DESC_4: q3x_FunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 400)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.HEADER_LANG_PT_DESC_4?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                            </>)
                    }
                    {
                        prop.LANG_EN == "Y" && 
                            (<>
                                <p className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 401)}</p>
                                <InputGeneral 
                                    value={prop.HEADER_LANG_EN_DESC_1 || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2, MainStyle.text_wrap].join(" ")}
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    HEADER_LANG_EN_DESC_1: q3x_FunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 400)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop.HEADER_LANG_EN_DESC_1.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                                <InputGeneral 
                                    value={prop.HEADER_LANG_EN_DESC_2 || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2, MainStyle.text_wrap].join(" ")}
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    HEADER_LANG_EN_DESC_2: q3x_FunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 400)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop.HEADER_LANG_EN_DESC_2.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                                <InputGeneral 
                                    value={prop.HEADER_LANG_EN_DESC_3 || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2, MainStyle.text_wrap].join(" ")}
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    HEADER_LANG_EN_DESC_3: q3x_FunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 400)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop.HEADER_LANG_EN_DESC_3.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                                <InputGeneral 
                                    value={prop.HEADER_LANG_EN_DESC_4 || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2, MainStyle.text_wrap].join(" ")}
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    HEADER_LANG_EN_DESC_4: q3x_FunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 400)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop.HEADER_LANG_EN_DESC_4.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                            </>)
                    }
                                        {
                        prop.LANG_ES == "Y" && 
                            (<>
                                <p className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 402)}</p>
                                <InputGeneral 
                                    value={prop.HEADER_LANG_ES_DESC_1 || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2, MainStyle.text_wrap].join(" ")}
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    HEADER_LANG_ES_DESC_1: q3x_FunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 400)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.HEADER_LANG_ES_DESC_1?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                                <InputGeneral 
                                    value={prop.HEADER_LANG_ES_DESC_2 || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2, MainStyle.text_wrap].join(" ")}
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    HEADER_LANG_ES_DESC_2: q3x_FunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 400)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.HEADER_LANG_ES_DESC_2?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                                <InputGeneral 
                                    value={prop.HEADER_LANG_ES_DESC_3 || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2, MainStyle.text_wrap].join(" ")}
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    HEADER_LANG_ES_DESC_3: q3x_FunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 400)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.HEADER_LANG_ES_DESC_3?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                                <InputGeneral 
                                    value={prop.HEADER_LANG_ES_DESC_4 || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2, MainStyle.text_wrap].join(" ")} 
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    HEADER_LANG_ES_DESC_4: q3x_FunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 400)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.HEADER_LANG_ES_DESC_4?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                            </>)
                    }
                </div>
            </div>
        </div>
    );
});
const Tab_1_Block_1 = React.memo(({prop, setProp, metaProp}) => {
    const [ displayModal,     setDisplayModal         ]  = useState(false);
    const [ innerCompID,      setInnerCompID          ]  = useState(0);

    useEffect(() =>{
    }, [prop, setProp]);

    return (
        <>
            <SelectLogoPopup 
                displayModal={displayModal} 
                setDisplayModal={setDisplayModal}
                mainDataset={prop}
                objectSet={setProp}
                dataset={metaProp?.ORDER_SETTINGS?.LOGOS}
                compID={innerCompID}
            />
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    {
                        prop.LOGO1 !=0 && prop.LOGO1 !=null ?
                            <div className={[MainStyle.mx_1, MainStyle.my_1].join(" ")}>
                                <img 
                                    src={getImgSrc(prop.LOGO1_DATA)}
                                    style={{width: '100%', height: 'auto', objectFit:'cover', objectPosition: '50% 50%'}}
                                />
                            </div>
                        :
                            <div className={[MainStyle.mx_1, MainStyle.my_1].join(" ")}>
                                <Landscape/>
                            </div>
                    }
                    {
                        prop.LOGO1 !=0 && prop.LOGO1 !=null ?
                            <div className={[MainStyle.mx_1, MainStyle.my_1].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={() => {
                                        stateManager({
                                            setObjectState: setProp,
                                            objectValue: {
                                                LOGO1: 0,
                                                LOGO1_DATA: "",
                                            }
                                        });
                                    }}
                                >
                                    {GetLabel(appLang, 364)}
                                </button>
                            </div>

                        :
                            <div className={[MainStyle.mx_1, MainStyle.my_1].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_blue, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_7,
                                                MainStyle.text_white,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={() => {
                                        setInnerCompID(0);
                                        setDisplayModal(true);
                                    }}
                                >                                    
                                    {GetLabel(appLang, 403)}
                                </button>
                            </div>
                    }                    
                </div>
                <div className={MainStyle.col_lg}>
                    {
                        prop.LOGO2 !=0 && prop.LOGO2 !=null ?
                            <div className={[MainStyle.mx_1, MainStyle.my_1].join(" ")}>
                                <img 
                                    src={getImgSrc(prop.LOGO2_DATA)}
                                    style={{width: '100%', height: 'auto', objectFit:'cover', objectPosition: '50% 50%'}}
                                />
                            </div>
                        :
                            <div className={[MainStyle.mx_1, MainStyle.my_1].join(" ")}>
                                <Landscape/>
                            </div>
                    }
                    {
                        prop.LOGO2 !=0 && prop.LOGO2 !=null ?
                            <div className={[MainStyle.mx_1, MainStyle.my_1].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={() => {
                                        stateManager({
                                            setObjectState: setProp,
                                            objectValue: {
                                                LOGO2: 0,
                                                LOGO2_DATA: "",
                                            }
                                        });
                                    }}
                                >
                                    {GetLabel(appLang, 364)}
                                </button>
                            </div>

                        :
                            <div className={[MainStyle.mx_1, MainStyle.my_1].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_blue, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_7,
                                                MainStyle.text_white,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={() => {
                                        setInnerCompID(1);
                                        setDisplayModal(true);
                                    }}
                                >
                                    {GetLabel(appLang, 403)}
                                </button>
                            </div>
                    }                    
                </div>
                <div className={MainStyle.col_lg}>
                    {
                        prop.LOGO3 !=0 && prop.LOGO3 !=null ?
                            <div className={[MainStyle.mx_1, MainStyle.my_1].join(" ")}>
                                <img 
                                    src={getImgSrc(prop.LOGO3_DATA)}
                                    style={{width: '100%', height: 'auto', objectFit:'cover', objectPosition: '50% 50%'}}
                                />
                            </div>
                        :
                            <div className={[MainStyle.mx_1, MainStyle.my_1].join(" ")}>
                                <Landscape/>
                            </div>
                    }
                    {
                        prop.LOGO3 !=0 && prop.LOGO3 !=null ?
                            <div className={[MainStyle.mx_1, MainStyle.my_1].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={() => {
                                        stateManager({
                                            setObjectState: setProp,
                                            objectValue: {
                                                LOGO3: 0,
                                                LOGO3_DATA: "",
                                            }
                                        });
                                    }}
                                >
                                    {GetLabel(appLang, 364)}
                                </button>
                            </div>

                        :
                            <div className={[MainStyle.mx_1, MainStyle.my_1].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_blue, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_7,
                                                MainStyle.text_white,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={() => {
                                        setInnerCompID(2);
                                        setDisplayModal(true);
                                    }}
                                >
                                    {GetLabel(appLang, 403)}
                                </button>
                            </div>
                    }                    
                </div>
            </div>
        </>
    );
});
const Tab_1_Block_2 = React.memo(({prop, setProp}) => {
    useEffect(() =>{
    }, [prop, setProp]);

    return (
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                    <span className={[MainStyle.fs_6, MainStyle.fw_semibold, MainStyle.text_body, MainStyle.mx_3].join(" ")}>{GetLabel(appLang, 404)}</span>
                </div>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3].join(" ")}>
                    <input
                        type="checkbox"
                        name={"read"}
                        checked={prop.EXPLAN_LANG === "Y" ? true : false}
                        onChange={()=> {
                            prop.EXPLAN_LANG === "Y" ?
                                stateManager({
                                    setObjectState: setProp,
                                    objectValue: {
                                        EXPLAN_LANG: "N"
                                    }
                                })
                            :
                                stateManager({
                                    setObjectState: setProp,
                                    objectValue: {
                                        EXPLAN_LANG: "Y"
                                    }
                                })
                        }}
                        style={{ transform: "scale(1.5)" }}
                        disabled={false}
                    />
                </div>
                {
                    prop.EXPLAN_LANG == "Y" ?
                        <div className={MainStyle.mx_3}>
                        {prop.LANG_PT == "Y" && 
                            (<>
                                <p className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 405)}</p>
                                <InputGeneral 
                                    value={prop.EXPLAN_LANG_PT_DESC.replaceAll('|n|', '\n') || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2].join(" ")} 
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    EXPLAN_LANG_PT_DESC: q3x_CustomFunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 36)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.EXPLAN_LANG_PT_DESC?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                            </>)}
                        {prop.LANG_EN == "Y" && 
                            (<>
                                <p className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 406)}</p>
                                <InputGeneral 
                                    value={prop.EXPLAN_LANG_EN_DESC.replaceAll('|n|', '\n') || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2].join(" ")} 
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    EXPLAN_LANG_EN_DESC: q3x_CustomFunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 36)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.EXPLAN_LANG_EN_DESC?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                            </>)}
                        {prop.LANG_ES == "Y" && 
                            (<>
                                <p className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 407)}</p>
                                <InputGeneral 
                                    value={prop.EXPLAN_LANG_ES_DESC.replaceAll('|n|', '\n') || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2].join(" ")} 
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    EXPLAN_LANG_ES_DESC: q3x_CustomFunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 36)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.EXPLAN_LANG_ES_DESC?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                            </>)}
                        </div>
                    :
                        null
                }
            </div>
            <div className={MainStyle.col_lg}>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                    <span className={[MainStyle.fs_6, MainStyle.fw_semibold, MainStyle.text_body, MainStyle.mx_3].join(" ")}>{GetLabel(appLang, 408)}</span>
                </div>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_3].join(" ")}>
                    <input
                        type="checkbox"
                        name={"read"}
                        checked={prop.SUBTI_LANG === "Y" ? true : false}
                        onChange={()=> {
                            prop.SUBTI_LANG === "Y" ?
                                stateManager({
                                    setObjectState: setProp,
                                    objectValue: {
                                        SUBTI_LANG: "N"
                                    }
                                })
                            :
                                stateManager({
                                    setObjectState: setProp,
                                    objectValue: {
                                        SUBTI_LANG: "Y"
                                    }
                                })
                        }}
                        style={{ transform: "scale(1.5)" }}
                        disabled={false}
                    />
                </div>
                {
                    prop.SUBTI_LANG == "Y" ?
                        <div className={MainStyle.mx_3}>
                        {prop.LANG_PT == "Y" && 
                            (<>
                                <p className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 409)}</p>
                                <InputGeneral 
                                    value={prop.SUBTI_LANG_PT_DESC.replaceAll('|n|', '\n') || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2].join(" ")} 
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    SUBTI_LANG_PT_DESC: q3x_CustomFunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 36)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.SUBTI_LANG_PT_DESC?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                            </>)}
                        {prop.LANG_EN == "Y" && 
                            (<>
                                <p className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 410)}</p>
                                <InputGeneral 
                                    value={prop.SUBTI_LANG_EN_DESC.replaceAll('|n|', '\n') || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2].join(" ")} 
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    SUBTI_LANG_EN_DESC: q3x_CustomFunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 36)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.SUBTI_LANG_EN_DESC?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                            </>)}
                        {prop.LANG_ES == "Y" && 
                            (<>
                                <p className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 411)}</p>
                                <InputGeneral 
                                    value={prop.SUBTI_LANG_ES_DESC.replaceAll('|n|', '\n') || ''}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2].join(" ")} 
                                    onChange={(event) => { 
                                            stateManager({
                                                setObjectState: setProp,
                                                objectValue: {
                                                    SUBTI_LANG_ES_DESC: q3x_CustomFunData(event.target.value)
                                                }
                                            });
                                        }
                                    }
                                    placeholder={GetLabel(appLang, 36)}
                                    maxLength={500}
                                    autoSize={true}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{prop?.SUBTI_LANG_ES_DESC?.length} {GetLabel(appLang, 44)} 500 {GetLabel(appLang, 45)}.</span>
                            </>)}
                        </div>
                    :
                        null
                }
            </div>
        </div>
    );
});

const Tab_1 = React.memo(({...other}) => {
    const {prop, setProp, orderMeta} = other;
    return (
        <>
            <Tab_1_Block_0 prop={prop} setProp={setProp}/>
                <DefaultPadding/>
                <DivisionBlock/>
                <DefaultPadding/>
            <Tab_1_Block_1 prop={prop} setProp={setProp} metaProp={orderMeta}/>
                <DefaultPadding/>
                <DivisionBlock/>
                <DefaultPadding/>
            <Tab_1_Block_2 prop={prop} setProp={setProp}/>
                <DefaultPadding/>
        </>
    );

});
// #endregion

// #region Tab 2
const ListItem   = React.memo(({...other}) => {
    const { showInfoMessage   }                                 = useInfoMsgModal();                // Modal message control 
    const { showActionMessage }                                 = useActionModal(); 
    const {parent_idx, index, prop, setProp, mainProp, orderMeta, onDelete, onMove} = other;


    const handleChange = (value) => {
        setProp((prevState) => ({
            ...prevState,
            SESSIONS: prevState.SESSIONS.map((session, i) =>
              i === parent_idx
                ? {
                    ...session,
                    SESSION_LINES: session.SESSION_LINES.map((line, j) =>
                      j === index
                        ? {
                            ...line,
                            ...value
                          }
                        : line
                    )
                  }
                : session
            )
        }));
    };
    const handleDelete = () => {
        showActionMessage(
            { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 58)}<br/>{GetLabel(appLang, 59)}</> },
            { confirm_action: () => {onDelete(index);}}
        );
        return;
    };
    useEffect(() => {    
    },[other]);

    //5	linha de professor
    //6	Rótulo e texto
    return(
        <React.Fragment>
            {
                prop.TYPE_ID == 5 ?
                    <div style={{border: "1px solid  #d3d3d3", background: "repeating-linear-gradient(30deg, #2C5364,rgb(30, 108, 141) 6px,  #2C5364 5px"}} className={[MainStyle.row, MainStyle.rounded, MainStyle.text_white].join(" ")}>
                        <div className={MainStyle.col_lg}>
                            <div className={[MainStyle.m_2].join(" ")}>
                                <p className={[MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 143)}*</p>
                                <DropdownList
                                    value={prop.DESIGNATION_ID > 0 ? parseInt(prop.DESIGNATION_ID) : undefined}
                                    placeholder={GetLabel(appLang, 412)}
                                    listOfItems={ 
                                        orderMeta?.ORDER_SETTINGS?.DESIGNATIONS?.map((i) => (
                                                {value: i.DESIGNATION_ID, label: i.DESIGNATION_DESC}
                                            ))
                                    }
                                    style={{ width: "100%" }}
                                    className={[MainStyle.mt_2].join(" ")}
                                    onChange={(event) => {
                                        handleChange({DESIGNATION_ID: event});
                                    }}
                                />
                            </div>
                        </div>
                        <div className={MainStyle.col_lg}>
                            <div className={[MainStyle.m_2].join(" ")}>
                                <p className={[MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 413)}*</p>
                                <DropdownList
                                    value={prop.USER_ID > 0 ? parseInt(prop.USER_ID) : undefined}
                                    placeholder={GetLabel(appLang, 286)}
                                    listOfItems={ 
                                        orderMeta?.ORDER_SETTINGS?.USERS?.map((i) => (
                                                {value: i.USER_ID, label: i.FULL_NAME}
                                            ))
                                    }
                                    style={{ width: "100%" }}
                                    className={[MainStyle.mt_2].join(" ")}
                                    onChange={(event) => {
                                        handleChange({USER_ID: event});
                                    }}
                                />
                            </div>
                        </div>
                        {/*         Arrow up                   */}
                        <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_top].join(" ")}>
                            <div className={MainStyle.m_2}>
                                <div 
                                    onClick={() => {onMove(index, (index - 1))}}
                                    className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                    <svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                        <path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        {/*         Arrow down                 */}
                        <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_top].join(" ")}>
                            <div className={MainStyle.m_2}>
                                <div 
                                    onClick={() => {onMove(index, (index + 1))}}
                                    className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                    <svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                        <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        {/*         Ico Trash                   */}
                        <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_top].join(" ")}>
                            <div className={MainStyle.m_2}>
                                <div 
                                    onClick={() => {handleDelete()}}
                                    className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                    <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                        <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                :
                prop.TYPE_ID == 6 ?
                    <div style={{border: "1px solid  #d3d3d3", background: "repeating-linear-gradient(30deg, #2C5364,rgb(30, 108, 141) 6px,  #2C5364 5px"}} className={[MainStyle.row, MainStyle.rounded, MainStyle.text_white].join(" ")}>
                        <div className={MainStyle.col_lg_1}>
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                <p className={[MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 213)}</p>
                            </div>
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                <input
                                    type="checkbox"
                                    name={"read"}
                                    checked={prop.LBL_BOLD === "Y" ? true : false}
                                    onChange={()=> {
                                        prop.LBL_BOLD === "Y" ? 
                                            handleChange({LBL_BOLD: "N"})
                                        :
                                            handleChange({LBL_BOLD: "Y"})
                                        ;
                                    }}
                                    style={{ transform: "scale(1.5)" }}
                                    disabled={false}
                                />
                            </div>
                        </div>
                        <div className={MainStyle.col_lg}>
                            <div className={[MainStyle.m_2].join(" ")}>
                                <p className={[MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 414)}</p>
                                {mainProp.LANG_PT == "Y" && (
                                    <>
                                    <p className={[MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 415)}</p>
                                    <InputGeneral 
                                            value={prop.LBL_LANG_PT_DESC || ''}
                                            className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                            onChange={(event) => {
                                                handleChange({LBL_LANG_PT_DESC: q3x_FunData(event.target.value)});
                                            }}
                                            placeholder={GetLabel(appLang, 36)}
                                            maxLength={500}
                                            autoSize={true}
                                    />
                                    </>
                                )}
                                {mainProp.LANG_EN == "Y" && (
                                    <>
                                    <p className={[MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 416)}</p>
                                    <InputGeneral 
                                        value={prop.LBL_LANG_EN_DESC || ''}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => {
                                            handleChange({LBL_LANG_EN_DESC: q3x_FunData(event.target.value)});
                                        }}
                                        placeholder={GetLabel(appLang, 36)}
                                        maxLength={500}
                                        autoSize={true}
                                    />
                                    </>
                                )}
                                {mainProp.LANG_ES == "Y" && (
                                    <>
                                    <p className={[MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 417)}</p>
                                    <InputGeneral 
                                        value={prop.LBL_LANG_ES_DESC || ''}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => {
                                            handleChange({LBL_LANG_ES_DESC: q3x_FunData(event.target.value)});
                                        }}
                                        placeholder={GetLabel(appLang, 36)}
                                        maxLength={500}
                                        autoSize={true}
                                    />
                                    </>
                                )}
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}>
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                <p className={[MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 213)}</p>
                            </div>                                
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                <input
                                    type="checkbox"
                                    name={"read"}
                                    checked={prop.TXT_BOLD === "Y" ? true : false}
                                    onChange={()=> {
                                        prop.TXT_BOLD === "Y" ? 
                                            handleChange({TXT_BOLD: "N"})
                                        :
                                            handleChange({TXT_BOLD: "Y"})
                                        ;
                                    }}
                                    style={{ transform: "scale(1.5)" }}
                                    disabled={false}
                                />
                            </div>
                        </div>                    
                        <div className={MainStyle.col_lg}>
                            <div className={[MainStyle.m_2].join(" ")}>
                                <p className={[MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 418)}</p>
                                {mainProp.LANG_PT == "Y" && (
                                    <>
                                    <p className={[MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 419)}</p>
                                    <InputGeneral 
                                        value={prop.TXT_LANG_PT_DESC || ''}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => {
                                            handleChange({TXT_LANG_PT_DESC: q3x_FunData(event.target.value)});
                                        }}
                                        placeholder={GetLabel(appLang, 36)}
                                        maxLength={500}
                                        autoSize={true}
                                    />
                                    </>                               
                                )}
                                {mainProp.LANG_EN == "Y" && (
                                    <>
                                    <p className={[MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 420)}</p>
                                    <InputGeneral 
                                        value={prop.TXT_LANG_EN_DESC || ''}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => {handleChange({TXT_LANG_EN_DESC: q3x_FunData(event.target.value)});}}
                                        placeholder={GetLabel(appLang, 36)}
                                        maxLength={500}
                                        autoSize={true}
                                    />
                                    </>
                                )}
                                {mainProp.LANG_ES == "Y" && (
                                    <>
                                    <p className={[MainStyle.fs_7, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 421)}</p>
                                    <InputGeneral 
                                        value={prop.TXT_LANG_ES_DESC || ''}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => {handleChange({TXT_LANG_ES_DESC: q3x_FunData(event.target.value)});}}
                                        placeholder={GetLabel(appLang, 36)}
                                        maxLength={500}
                                        autoSize={true}
                                    />
                                    </>
                                )}
                            </div>
                        </div>

                        {/*         Arrow up                   */}
                        <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_top].join(" ")}>
                            <div className={MainStyle.m_2}>
                                <div 
                                    onClick={() => {onMove(index, (index - 1))}}
                                    className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                    <svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                        <path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        {/*         Arrow down                 */}
                        <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_top].join(" ")}>
                            <div className={MainStyle.m_2}>
                                <div 
                                    onClick={() => {onMove(index, (index + 1))}}
                                    className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                    <svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                        <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        {/*         Ico Trash                   */}
                        <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_top].join(" ")}>
                            <div className={MainStyle.m_2}>
                                <div 
                                    onClick={() => {handleDelete()}}
                                    className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                    <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                        <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                :
                    null

            }
        </React.Fragment>
    );
});

const ItemList = React.memo(({...other}) => {
    const {parent_idx, prop, setProp, mainProp, orderMeta} = other;

    function handleItemDelete(item_position) {
        setProp(prevState => {
            const updatedSessions = prevState.SESSIONS.map((session, i) => {
              if (i !== parent_idx) return session;
        
              const updatedLines = session.SESSION_LINES.filter(
                (item, j) => j  !== item_position
              );
        
              const reorderedLines = updatedLines.map((item, idx) => ({
                ...item,
                LINE_ORDER: idx + 1
              }));
              return {
                ...session,
                SESSION_LINES: reorderedLines
              };
            });
            return {
                ...prevState,
                SESSIONS: updatedSessions
            };
        });
    }
    function handleReorderChange(current_position, desired_position) {
        if (current_position == 0 && desired_position < 0) {return;}
        setProp(prevState => {
            const updatedSessions = prevState.SESSIONS.map((session, i) => {
                if (i !== parent_idx) return session;
    
                // Clone SESSION_LINES
                const lines = [...session.SESSION_LINES];
                
                // Remove the item from its current position
                const [movedItem] = lines.splice(current_position, 1);
    
                // Insert it into the desired position
                lines.splice(desired_position, 0, movedItem);
    
                // Reassign LINE_ORDER based on new position
                const reorderedLines = lines.map((item, idx) => ({
                    ...item,
                    LINE_ORDER: idx + 1,
                }));
    
                return {
                    ...session,
                    SESSION_LINES: reorderedLines,
                };
            });
    
            return {
                ...prevState,
                SESSIONS: updatedSessions,
            };
        });
    }

    const renderItem    = useCallback((parent_idx, index, prop, setProp, orderMeta) => {
        return (
            <ListItem
                key={prop.LINE_ORDER}
                parent_idx={parent_idx}
                index={index}
                prop={prop}
                setProp={setProp}
                mainProp={mainProp}
                orderMeta={orderMeta}
                onDelete={handleItemDelete}
                onMove={handleReorderChange}

            />
        );
    }, []);
    
    return (
        <>
            {
                prop.SESSION_LINES.map((item, index) => renderItem(parent_idx,
                                                                       index,  
                                                                       item,
                                                                       setProp,
                                                                       orderMeta))
            }
        </>
    );

});

const QuestionListItem   = React.memo(({...other}) => {
    const { showInfoMessage   }                                 = useInfoMsgModal();                // Modal message control 
    const { showActionMessage }                                 = useActionModal(); 
    const {parent_idx, index, prop, setProp, mainProp, orderMeta, onDelete, onMove} = other;

    function getQuestionLang(){
        for(let i = 0; i < orderMeta.ORDER_SETTINGS.QUESTIONS.length; i++) {
            if (prop.QUESTION_ID === orderMeta.ORDER_SETTINGS.QUESTIONS[i].QUESTION_ID) {
                let label = [];
                orderMeta.ORDER_SETTINGS.QUESTIONS[i].LANG_PT === "Y" && label.push(GetLabel(appLang, 204));
                orderMeta.ORDER_SETTINGS.QUESTIONS[i].LANG_EN === "Y" && label.push(GetLabel(appLang, 205));
                orderMeta.ORDER_SETTINGS.QUESTIONS[i].LANG_ES === "Y" && label.push(GetLabel(appLang, 206));
                return(label.join(" ,"));
            }
        }
    };
    function getQuestionDesc(){
        for(let i = 0; i < orderMeta.ORDER_SETTINGS.QUESTIONS.length; i++) {
            if (prop.QUESTION_ID === orderMeta.ORDER_SETTINGS.QUESTIONS[i].QUESTION_ID) {
                return(orderMeta.ORDER_SETTINGS.QUESTIONS[i].QUESTION_DESC);
            }
        }
    };

    const handleChange = (value) => {
        setProp((prevState) => ({
            ...prevState,
            SESSIONS: prevState.SESSIONS.map((session, i) =>
              i === parent_idx
                ? {
                    ...session,
                    SESSION_QUESTIONS: session.SESSION_QUESTIONS.map((question, j) =>
                      j === index
                        ? {
                            ...question,
                            ...value
                          }
                        : question
                    )
                  }
                : session
            )
        }));
    };
    const handleDelete = () => {
        showActionMessage(
            { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 58)}<br/>{GetLabel(appLang, 59)}</> },
            { confirm_action: () => {onDelete(index);}}
        );
        return;
    };

    useEffect(() => {},[other]);

    return(
        <React.Fragment>
            <div style={{background: "repeating-linear-gradient(30deg, #353B3C,rgb(26, 28, 29)2px, #353B3C 6px", border: "1px solid  #d3d3d3"}}
                 className={[MainStyle.row,
                             MainStyle.py_1, 
                             MainStyle.shadow_sm,
                             MainStyle.text_white].join(" ")}>
                {/*           Item position            */}                
                <div className={[MainStyle.col_sm_1, MainStyle.align_items_center, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                    <span className={[  MainStyle.fs_7, MainStyle.fw_semibold, MainStyle.mt_1].join(" ")}>
                        { index  + 1 }
                    </span>    
                </div>
                {/*           Question Description            */}                
                <div className={MainStyle.col_sm}>
                    <div className={MainStyle.m_2}>
                        <div>
                            <span className={[  MainStyle.fs_7, MainStyle.fw_semibold, MainStyle.mt_1].join(" ")}>
                                {GetLabel(appLang, 207)}
                            </span>
                        </div>
                        <div>
                            <span className={[  MainStyle.fs_7, MainStyle.mt_1].join(" ")}>
                                { getQuestionDesc () }
                            </span>
                        </div>
                    </div>
                </div>
                {/*           Get Question Lang               */}
                <div className={MainStyle.col_sm}>
                    <div className={MainStyle.m_2}>
                        <div>
                            <span className={[  MainStyle.fs_7, MainStyle.fw_semibold, MainStyle.mt_1].join(" ")}>
                                {GetLabel(appLang, 422)}
                            </span>
                        </div>
                        <div>
                            <span className={[  MainStyle.fs_7, MainStyle.mt_1].join(" ")}>
                                { getQuestionLang() }
                            </span>
                        </div>
                    </div>
                </div>                
                {/*         Prefix Description         */}
                <div className={MainStyle.col_sm}>
                    <div className={MainStyle.m_2}>
                        <span className={[MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                            {GetLabel(appLang, 210)}
                        </span>
                        <InputGeneral 
                            value={prop.PREFIX || ''}
                            className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                            onChange={(event) => {
                                handleChange({PREFIX: q3x_FunData(event.target.value)});
                            }}
                            placeholder={GetLabel(appLang, 423)}
                            maxLength={50}
                        />
                        <span className={[MainStyle.ms_2, MainStyle.fs_8].join(" ")}>
                            {prop?.PREFIX?.length} {GetLabel(appLang, 44)} 50 {GetLabel(appLang, 45)}.
                        </span>
                    </div>
                </div>
                {/*         Mandatory CheckMark        */}
                <div className={[MainStyle.col_sm, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                    <div className={MainStyle.m_2}>
                        <div>
                            <span className={[  MainStyle.fs_6,
                                                MainStyle.fw_semibold,].join(" ")}>
                                {GetLabel(appLang, 212)}
                            </span>
                        </div>
                        <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_2].join(" ")}>
                            <input
                                type="checkbox"
                                name={"read"}
                                checked={prop.MANDATORY === "Y" ? true : false}
                                onChange={()=> {
                                    prop.MANDATORY === "N"? 
                                            handleChange({MANDATORY: "Y"})
                                        : 
                                            handleChange({MANDATORY: "N"})
                                }}
                                style={{ transform: "scale(1.5)" }}
                                disabled={false}
                            />
                        </div>
                    </div>
                </div>
                {/*         Bold    Text              */}
                <div className={[MainStyle.col_sm, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                    <div className={MainStyle.m_2}>
                        <div>
                            <span className={[  MainStyle.fs_6,
                                                MainStyle.fw_semibold,].join(" ")}>
                                {GetLabel(appLang, 213)}
                            </span>
                        </div>
                        <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.mt_2].join(" ")}>
                                <input
                                    type="checkbox"
                                    name={"read"}
                                    checked={prop.BOLD === "Y" ? true : false}
                                    onChange={()=> {
                                        prop.BOLD === "N"? 
                                                handleChange({BOLD: "Y"})
                                            : 
                                                handleChange({BOLD: "N"})
                                    }}
                                    style={{ transform: "scale(1.5)" }}
                                    disabled={false}
                                />
                        </div>
                    </div>    
                </div>
                {/*         Arrow up                   */}
                <div className={[MainStyle.col_sm, MainStyle.d_flex, MainStyle.align_top, MainStyle.justify_content_center].join(" ")}>
                    <div className={MainStyle.m_2}>
                        <div
                            onClick={() => {onMove(index, (index - 1))}}
                            className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                            <svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                <path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"/>
                            </svg>
                        </div>
                    </div>
                </div>
                {/*         Arrow down                 */}
                <div className={[MainStyle.col_sm, MainStyle.d_flex, MainStyle.align_top, MainStyle.justify_content_center].join(" ")}>
                    <div className={MainStyle.m_2}>
                        <div 
                            onClick={() => {onMove(index, (index + 1))}}
                            className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                            <svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/>
                            </svg>
                        </div>
                    </div>
                </div>
                {/*         Ico Trash                   */}
                <div className={[MainStyle.col_sm, MainStyle.d_flex, MainStyle.align_top, MainStyle.justify_content_center].join(" ")}>
                    <div className={MainStyle.m_2}>
                        <div 
                            onClick={() => {handleDelete()}}
                            className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                            <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
});

const QuestionItemList = React.memo(({...other}) => {
    const {parent_idx, prop, setProp, mainProp, orderMeta} = other;
    const [ expanded, setExpanded ] = useState(false);

    function handleItemDelete(item_position) {
        setProp(prevState => {
            const updatedSessions = prevState.SESSIONS.map((session, i) => {
              if (i !== parent_idx) return session;
        
              const updatedLines = session.SESSION_QUESTIONS.filter(
                (item, j) => j  !== item_position
              );
        
              const reorderedLines = updatedLines.map((item, idx) => ({
                ...item,
                QUESTION_POSITION: idx + 1
              }));
              return {
                ...session,
                SESSION_QUESTIONS: reorderedLines
              };
            });
            return {
                ...prevState,
                SESSIONS: updatedSessions
            };
        });
    }
    function handleReorderChange(current_position, desired_position) {
        if (current_position == 0 && desired_position < 0) {
            return;
        }
        setProp(prevState => {
            const updatedSessions = prevState.SESSIONS.map((session, i) => {
                if (i !== parent_idx) return session;
    
                // Clone SESSION_QUESTIONS
                const lines = [...session.SESSION_QUESTIONS];
                
                // Remove the item from its current position
                const [movedItem] = lines.splice(current_position, 1);
    
                // Insert it into the desired position
                lines.splice(desired_position, 0, movedItem);
    
                // Reassign QUESTION_POSITION based on new position
                const reorderedLines = lines.map((item, idx) => ({
                    ...item,
                    QUESTION_POSITION: idx + 1,
                }));
    
                return {
                    ...session,
                    SESSION_QUESTIONS: reorderedLines,
                };
            });
    
            return {
                ...prevState,
                SESSIONS: updatedSessions,
            };
        });
    }

    const renderItem    = useCallback((parent_idx, index, prop, setProp, orderMeta) => {
        return (
            <QuestionListItem
                //key={prop.LINE_ORDER}
                parent_idx={parent_idx}
                index={index}
                prop={prop}
                setProp={setProp}
                mainProp={mainProp}
                orderMeta={orderMeta}
                onDelete={handleItemDelete}
                onMove={handleReorderChange}

            />
        );
    }, []);
    
    return (
        <React.Fragment>
            {expanded ? 
                <React.Fragment>
                    <div style={{background: "#7B1E7A"}} className={[MainStyle.row, MainStyle.rounded_top_1].join(" ")}>
                        <div className={MainStyle.col}>
                                <span className={[  
                                                    MainStyle.mx_3,
                                                    MainStyle.fs_7,
                                                    MainStyle.text_white,
                                                    MainStyle.fw_semibold].join(" ")}>
                                    {GetLabel(appLang, 424)}
                                </span>
                        </div>
                        <div className={MainStyle.col}>
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_end].join(" ")}>
                                <div 
                                    onClick={() => {setExpanded(false);}}
                                    className={[MainStyle.shadow_sm, MainStyle.rounded_top_1, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                        <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        {prop.SESSION_QUESTIONS.map((item, index) => renderItem(parent_idx,
                                                                            index,  
                                                                            item,
                                                                            setProp,
                                                                            orderMeta))
                        }
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div style={{background: "#7B1E7A"}} className={[MainStyle.row, MainStyle.rounded_top_1].join(" ")}>
                        <div className={MainStyle.col}>
                                <span className={[  
                                                    MainStyle.mx_3,
                                                    MainStyle.fs_7,
                                                    MainStyle.text_white,
                                                    MainStyle.fw_semibold].join(" ")}>
                                    {GetLabel(appLang, 424)}
                                </span>
                        </div>
                        <div className={MainStyle.col}>
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_end].join(" ")}>
                                <div 
                                    onClick={() => {setExpanded(true);}}
                                    className={[MainStyle.shadow_sm, MainStyle.rounded_top_1, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                        <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );

});

const ItemBlock =  React.memo(({...other}) => {
    const { index, 
            mainProp, 
            orderMeta, 
            prop, 
            setProp, 
            moveItem, 
            onDelete            }                               = other;
    const { showInfoMessage     }                               = useInfoMsgModal();                // Modal message control 
    const { showActionMessage   }                               = useActionModal();                 // Modal message + action control     
    const { showToastMessage    }                               = useToastMessage();                // Toast message display
    const itemRef                                               = useRef(null);
    const [expanded, setExpanded]                               = useState(null);
    const [patternList, setPatternList]                         = useState([]);

    const handleInputChange = (field, value) => {
        setProp(prev => {
          const newItems = [...prev.SESSIONS];
          newItems[index] = {
            ...newItems[index],
            ...{[field] : value}
          };
          return {
            ...prev,
            SESSIONS: newItems
          };
        });
    };

    function insertPatternTemplate(d){
        let dataset = [];
        for (let i = 0; i < orderMeta?.ORDER_SETTINGS?.PATTERNS?.length; i++) {
            if (orderMeta.ORDER_SETTINGS.PATTERNS[i].PATTERN_ID === d) {
                let k = 0;
                while(k < orderMeta.ORDER_SETTINGS.PATTERNS[i].QUESTIONS.length) {
                    dataset.push(
                        { 
                            ORDER_ID: mainProp.ORDER_ID,
                            SESSION_ORDER: index + 1,
                            PATTERN_TEMPLATE: orderMeta.ORDER_SETTINGS.PATTERNS[i].PATTERN_ID,
                            QUESTION_ID: orderMeta.ORDER_SETTINGS.PATTERNS[i].QUESTIONS[k].QUESTION_ID, 
                            QUESTION_POSITION: orderMeta.ORDER_SETTINGS.PATTERNS[i].QUESTIONS[k].QUESTION_POSITION,
                            MANDATORY: orderMeta.ORDER_SETTINGS.PATTERNS[i].QUESTIONS[k].MANDATORY,
                            BOLD: orderMeta.ORDER_SETTINGS.PATTERNS[i].QUESTIONS[k].BOLD,
                            PREFIX: orderMeta.ORDER_SETTINGS.PATTERNS[i].QUESTIONS[k].PREFIX,
                        }
                    );
                    k++;
                }
                break;
            }
        }
        if (dataset.length > 0 ) {
            handleInputChange("SESSION_QUESTIONS", dataset);
        }
    }

    function insertQuestion(d) {
        let obj = null;
        let template = 0;
        for (let i = 0; i < orderMeta?.ORDER_SETTINGS?.QUESTIONS.length; i++) {
            if (orderMeta.ORDER_SETTINGS.QUESTIONS[i].QUESTION_ID === d) {
                obj = orderMeta.ORDER_SETTINGS.QUESTIONS[i];
                break;
            }
        }
        if (prop?.SESSION_QUESTIONS?.length > 0) {
            template = prop.SESSION_QUESTIONS[0].PATTERN_TEMPLATE;
        }

        if (obj) {
            setProp((prevState) => ({
                ...prevState,
                SESSIONS: prevState.SESSIONS.map((session, i) =>
                    i === index
                        ? {
                            ...session,
                            SESSION_QUESTIONS: [
                                ...session.SESSION_QUESTIONS,
                                {
                                    ORDER_ID: mainProp.ORDER_ID,
                                    SESSION_ORDER: index + 1,
                                    PATTERN_TEMPLATE: template,
                                    QUESTION_ID: obj.QUESTION_ID,
                                    QUESTION_POSITION: session.SESSION_QUESTIONS.length + 1,
                                    MANDATORY: "N",
                                    BOLD: "N",
                                    PREFIX: "",
                                },
                            ],
                        }
                        : session
                ),
            }));
        }
    }

    const handleEdit = () => {
        if (!prop.IsEditing) {
            handleInputChange("IsEditing", true);
        }
        else {
            handleInputChange("IsEditing", false);
        }
    };

    const handleDelete = () => {
        if (mainProp.SESSIONS.length == 1 ) {
            showInfoMessage({ 
                header: GetLabel(appLang, 54), 
                message: <>{GetLabel(appLang, 425)}</> 
            });
            return;
        }
        showActionMessage(
            { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 58)}<br/>{GetLabel(appLang, 59)}</> },
            { confirm_action: () => {onDelete(index);}}
        );
        return;
    };

    const [{ handlerId }, drop]  = useDrop(
        {
        accept: 'card',        
        collect(monitor) {
          return {
            handlerId: monitor.getHandlerId(),
          }
        },
        hover(item, monitor) {
            if (!itemRef.current) {
              return;
            }
          
            const dragIndex = item.index;
            const hoverIndex = index;
          
            // Do nothing if dragging over itself
            if (dragIndex === hoverIndex) {
              return;
            }
          
            // Get bounding rectangle
            const hoverBoundingRect = itemRef.current.getBoundingClientRect();        
          
            // Get vertical middle
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
          
            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
          
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
          
            // Only perform the move when the mouse has crossed half of the item's height
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
              return;
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
              return;
            }
          
            // Time to actually perform the action
            moveItem(dragIndex, hoverIndex);
          
            // Note: mutate the monitor item to update the index
            item.index = hoverIndex;
          }
    });
    
    const [{ isDragging }, drag] = useDrag({
        type: 'card',
        item: () => {
          const id = prop.OPTION_LIST_ITEM_ORDER;
          return { id, index };
        },
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
        }),
    });
    const opacity                = isDragging ? 0.4 : 1;

    drag(drop(itemRef));
    
    const addNewLine = (type_id) => {
        //5	linha de professor
        //6	Rótulo e texto
        const newObject = {
            ...blank_session_line_obj, // Copy the template
            SESSION_ORDER    : index  + 1,
            TYPE_ID          : type_id,
            LINE_ORDER       : prop.SESSION_LINES.length + 1,
            DESIGNATION_ID   : 0   ,
            USER_ID          : 0   ,
            STUDY_CASE_ID    : 0   ,
        };
        setProp((prevState) => ({
            ...prevState,
            SESSIONS: prevState.SESSIONS.map((session, i) =>
                i === index ? 
                    {...session, SESSION_LINES: [...session.SESSION_LINES, newObject]}
                : 
                    session
                )
        }));
    };
    
    useEffect(() => {
        function handlePatternDataset() {
            if (!orderMeta?.ORDER_SETTINGS?.PATTERNS) return;
    
            const enabledLangs = ['PT', 'EN', 'ES'].filter(
                lang => mainProp[`LANG_${lang}`] === 'Y'
            );
    
            const langList = orderMeta.ORDER_SETTINGS.PATTERNS
                .filter(pattern => 
                    pattern.QUESTIONS.every(q =>
                        enabledLangs.every(lang => q[`LANG_${lang}`] === 'Y')
                    )
                )
                .map(pattern => ({
                    value: pattern.PATTERN_ID,
                    label: pattern.PATTERN_DESC
                }
                ));
    
            setPatternList(langList);
        }
    
        handlePatternDataset();
    }, [mainProp, orderMeta]);

    useEffect(() => {
        prop.IsEditing == true ? setExpanded(true) : setExpanded(false);
    }, [expanded, prop.IsEditing]);
    return (
        <>
            <div
                data-handler-id={handlerId}
                ref={itemRef}
                style={{ opacity, cursor: 'grab' }}
                className={[MainStyle.row, MainStyle.align_items_center, MainStyle.mx_3, MainStyle.bg_card_item, MainStyle.shadow_sm, MainStyle.border, MainStyle.rounded].join(" ")}>
                { expanded ?
                    <>
                        <div className={[MainStyle.row, MainStyle.bg_header_item, MainStyle.rounded_top_1].join(" ")}>
                            <div className={MainStyle.col}>
                                <div className={[MainStyle.d_flex, MainStyle.justify_content_end].join(" ")}>
                                    <div 
                                        onClick={() => {handleEdit();}}
                                        className={[MainStyle.shadow_sm, MainStyle.rounded_top_1, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={MainStyle.row}>
                            {/*         Item Position               */}
                            <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_self_center, MainStyle.justify_content_center].join(" ")}>
                                <span className={[  
                                                    MainStyle.fs_7,
                                                    MainStyle.text_body,
                                                    MainStyle.fw_semibold].join(" ")}>
                                    { index  + 1 }
                                </span>                                
                            </div>
                            {/*               Main                 */}
                            <div className={[MainStyle.col_lg, MainStyle.border_start, MainStyle.border_end, MainStyle.border_bottom].join(" ")}>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={MainStyle.m_2}>
                                            <span className={[  MainStyle.fs_6,
                                                                MainStyle.text_body,
                                                                MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(appLang, 426)}
                                            </span>
                                            <InputGeneral 
                                                value={prop.SESSION_DESC || ''}
                                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                onChange={(event) => handleInputChange("SESSION_DESC", q3x_FunData(event.target.value))}
                                                placeholder={GetLabel(appLang, 427)}
                                                maxLength={150}
                                                autoSize={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/*         Academic Area           */}
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                                            <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 323)}*</span>
                                            <DropdownList
                                                value={prop.ACADEMIC_AREA_ID > 0 ? parseInt(prop.ACADEMIC_AREA_ID) : undefined}
                                                placeholder={GetLabel(appLang, 428)}
                                                listOfItems={ 
                                                    orderMeta?.ORDER_SETTINGS?.ACADEMIC_AREAS.map((i) => (
                                                            {value: i.ACADEMIC_AREA_ID, label: i.ACADEMIC_AREA_DESC}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    handleInputChange("ACADEMIC_AREA_ID", event);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/*         Course           */}
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                                            <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 632)}</span>
                                            <DropdownList
                                                value={prop.COURSE_ID > 0 ? parseInt(prop.COURSE_ID) : undefined}
                                                placeholder={GetLabel(appLang, 667)}
                                                listOfItems={ 
                                                    orderMeta?.ORDER_SETTINGS?.COURSES.map((i) => (
                                                            {value: i.COURSE_ID, label: i.COURSE_DESC}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    handleInputChange("COURSE_ID", event);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/*         External Course           */}
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                                            <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 639)}</span>
                                            <DropdownList
                                                value={prop.EXTERNAL_COURSE_ID > 0 ? parseInt(prop.EXTERNAL_COURSE_ID) : undefined}
                                                placeholder={GetLabel(appLang, 668)}
                                                listOfItems={ 
                                                    orderMeta?.ORDER_SETTINGS?.EXTERNAL_COURSES.map((i) => (
                                                            {value: i.EXTERNAL_COURSE_ID, label: i.EXTERNAL_COURSE_DESC}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    handleInputChange("EXTERNAL_COURSE_ID", event);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/*         Department           */}
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                                            <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 646)}</span>
                                            <DropdownList
                                                value={prop.DEPARTMENT_ID > 0 ? parseInt(prop.DEPARTMENT_ID) : undefined}
                                                placeholder={GetLabel(appLang, 669)}
                                                listOfItems={ 
                                                    orderMeta?.ORDER_SETTINGS?.DEPARTMENTS.map((i) => (
                                                            {value: i.DEPARTMENT_ID, label: i.DEPARTMENT_DESC}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    handleInputChange("DEPARTMENT_ID", event);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/*         Department           */}
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.mx_2, MainStyle.mt_1].join(" ")}>
                                            <span className={[MainStyle.fs_6,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 653)}</span>
                                            <DropdownList
                                                value={prop.EXTERNAL_DEPARTMENT_ID > 0 ? parseInt(prop.EXTERNAL_DEPARTMENT_ID) : undefined}
                                                placeholder={GetLabel(appLang, 670)}
                                                listOfItems={ 
                                                    orderMeta?.ORDER_SETTINGS?.EXTERNAL_DEPARTMENTS.map((i) => (
                                                            {value: i.EXTERNAL_DEPARTMENT_ID, label: i.EXTERNAL_DEPARTMENT_DESC}
                                                        ))
                                                }
                                                style={{ width: "100%" }}
                                                className={[MainStyle.mt_2].join(" ")}
                                                onChange={(event) => {
                                                    handleInputChange("EXTERNAL_DEPARTMENT_ID", event);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/*        Information about the theacher */}
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.my_3, MainStyle.mx_2].join(" ")}>
                                            <button
                                                style={{width: '100%'}}
                                                className={[MainStyle.btn_blue, 
                                                            MainStyle.rounded_3, 
                                                            MainStyle.border, 
                                                            MainStyle.shadow_sm, 
                                                            MainStyle.fs_7,
                                                            MainStyle.text_white,
                                                            MainStyle.py_2,
                                                            MainStyle.px_3].join(" ")}
                                                onClick={() => {addNewLine(5);}}
                                            >
                                                {GetLabel(appLang, 429)}
                                            </button>
                                        </div>
                                    </div>
                                    <div className={MainStyle.col_lg}>
                                        <div className={[MainStyle.my_3, MainStyle.mx_2].join(" ")}>
                                            <button
                                                style={{width: '100%'}}
                                                className={[MainStyle.btn_blue, 
                                                            MainStyle.rounded_3, 
                                                            MainStyle.border, 
                                                            MainStyle.shadow_sm, 
                                                            MainStyle.fs_7,
                                                            MainStyle.text_white,
                                                            MainStyle.py_2,
                                                            MainStyle.px_3].join(" ")}
                                                onClick={() => {addNewLine(6);}}
                                            >
                                                {GetLabel(appLang, 430)}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col}>
                                        <div className={[MainStyle.m_2].join(" ")}>
                                            <ItemList 
                                                parent_idx={index} 
                                                prop={prop} 
                                                setProp={setProp}
                                                orderMeta={orderMeta}
                                                mainProp={mainProp}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/*        Information about the pattern */}
                                <div className={MainStyle.row}>
                                    {/*         Pattern Selection       */}
                                    { prop?.SESSION_QUESTIONS?.length == 0 && (
                                        <div className={MainStyle.row}>
                                            <div className={MainStyle.col_lg}>
                                                <div className={[MainStyle.m_2].join(" ")}>
                                                    <span className={[MainStyle.fs_6, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 78)}*</span>
                                                    <DropdownList                                                        
                                                        value={prop.PATTERN_ID > 0 ? parseInt(prop.PATTERN_ID) : undefined}
                                                        placeholder={GetLabel(appLang, 431)}
                                                        listOfItems={patternList}
                                                        style={{ width: "100%" }}
                                                        className={[MainStyle.mt_2].join(" ")}
                                                        onChange={(event) => {
                                                            insertPatternTemplate(event);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {/*         Questions Block       */}
                                    { prop?.SESSION_QUESTIONS?.length > 0 && (
                                        <React.Fragment>
                                            {/*         Questions Selection     */}
                                            <div className={MainStyle.row}>
                                                <div className={MainStyle.col_lg}>
                                                    <div className={[MainStyle.m_2].join(" ")}>
                                                        <span className={[MainStyle.fs_6, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 432)}</span>
                                                        <DropdownList
                                                            value={null}
                                                            placeholder={GetLabel(appLang, 433)}
                                                            listOfItems={
                                                                orderMeta?.ORDER_SETTINGS?.QUESTIONS?.map((obj) => {
                                                                    return({
                                                                        value: obj.QUESTION_ID, label: obj.QUESTION_DESC
                                                                    });
                                                                })
                                                                
                                                            }
                                                            style={{ width: "100%" }}
                                                            className={[MainStyle.mt_2].join(" ")}
                                                            onChange={(event) => {
                                                                insertQuestion(event);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={[MainStyle.col_lg, MainStyle.align_self_center].join(" ")}>
                                                    <div className={[MainStyle.m_2].join(" ")}>
                                                        <button
                                                            style={{width: '100%'}}
                                                            className={[MainStyle.btn_delete, 
                                                                        MainStyle.rounded_3, 
                                                                        MainStyle.border, 
                                                                        MainStyle.shadow_sm, 
                                                                        MainStyle.fs_7,
                                                                        MainStyle.py_2,
                                                                        MainStyle.px_3].join(" ")}
                                                            onClick={() => {
                                                                handleInputChange("SESSION_QUESTIONS", []);
                                                            }}
                                                        >
                                                            {GetLabel(appLang, 434)}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*          Question List          */}
                                            <div className={MainStyle.row}>
                                                <div className={MainStyle.col_lg}>
                                                    <div className={[MainStyle.m_2].join(" ")}>
                                                        <QuestionItemList
                                                            parent_idx={index} 
                                                            prop={prop} 
                                                            setProp={setProp}
                                                            orderMeta={orderMeta}
                                                            mainProp={mainProp}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>                         
                            {/*         Ico Edit                    */}
                            <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_self_center, MainStyle.justify_content_center].join(" ")}>
                                <div className={MainStyle.m_2}>
                                    {
                                        prop.IsEditing ? 
                                            <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {handleEdit();}}>
                                                <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                                    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                                </svg>
                                            </div>
                                        :
                                            <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {handleEdit();}}>
                                                <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                                    <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                                                </svg>
                                            </div>
                                    }
                                </div>
                            </div>
                            {/*         Ico Trash                   */}
                            <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_self_center, MainStyle.justify_content_center].join(" ")}>
                                <div className={MainStyle.m_2}>
                                    <div 
                                        onClick={() => {handleDelete()}}
                                        className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                        <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            {/*         Ico Arrow Draggable         */}
                            <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_self_center, MainStyle.justify_content_center].join(" ")}>
                                <div className={MainStyle.m_2}>
                                    <div 
                                        className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                        <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3l0 293.5L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7l0-293.5 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"/>
                                        </svg>
                                    </div>
                                </div>                                            
                            </div>
                        </div>
                    </>
                :
                    <>
                        <div className={[MainStyle.row, MainStyle.bg_header_item, MainStyle.rounded_top_1].join(" ")}>
                            <div className={MainStyle.col}>
                                <div className={[MainStyle.d_flex, MainStyle.justify_content_end].join(" ")}>
                                    <div 
                                        onClick={() => {handleEdit();}}
                                        className={[MainStyle.shadow_sm, MainStyle.rounded_top_1, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={MainStyle.row}>
                            {/*         Item Position               */}
                            <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_self_center, MainStyle.justify_content_center].join(" ")}>
                                <span className={[  
                                                    MainStyle.fs_7,
                                                    MainStyle.text_body,
                                                    MainStyle.fw_semibold].join(" ")}>
                                    { index  + 1 }
                                </span>                                
                            </div>
                            {/*               Main                 */}
                            <div className={[MainStyle.col_lg].join(" ")}>
                                <div className={MainStyle.d_flex}>
                                    <div className={[MainStyle.align_self_center, MainStyle.mx_3, MainStyle.text_wrap].join(" ")}>
                                        <p className={[  MainStyle.fs_6,
                                                         MainStyle.text_body,
                                                         MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 426)}
                                        </p>
                                        <p className={[  MainStyle.fs_7, MainStyle.text_body, MainStyle.align_middle].join(" ")}>
                                                    {prop.SESSION_DESC || ''}
                                        </p>
                                    </div>
                                </div>
                            </div>                         
                            {/*         Ico Edit                    */}
                            <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_self_center, MainStyle.justify_content_center].join(" ")}>
                                <div className={MainStyle.m_2}>
                                    {
                                        prop.IsEditing ? 
                                            <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {handleEdit();}}>
                                                <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                                    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                                </svg>
                                            </div>
                                        :
                                            <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {handleEdit();}}>
                                                <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                                    <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                                                </svg>
                                            </div>
                                    }
                                </div>
                            </div>
                            {/*         Ico Trash                   */}
                            <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_self_center, MainStyle.justify_content_center].join(" ")}>
                                <div className={MainStyle.m_2}>
                                    <div 
                                        onClick={() => {handleDelete()}}
                                        className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                        <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            {/*         Ico Arrow Draggable         */}
                            <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.align_self_center, MainStyle.justify_content_center].join(" ")}>
                                <div className={MainStyle.m_2}>
                                    <div 
                                        className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                        <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3l0 293.5L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7l0-293.5 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"/>
                                        </svg>
                                    </div>
                                </div>                                            
                            </div>
                        </div>
                    </>
                }                    
            </div>
        </>
    );
});

const ListBlock = React.memo(({ prop, setProp, orderMeta }) => {
    const { backend, options } = GetDndBackend();

    const addNewItem    = () => {
        // Create a new object
        const newObject = {
            ...blank_session_obj, // Copy the template
            SESSION_ORDER    : prop.SESSIONS.length + 1,
            SESSION_DESC     : `${GetLabel(appLang, 563)} ${prop.SESSIONS.length + 1}`,
            PATTERN_ID       : 0,
            ACADEMIC_AREA_ID : 0,
            SESSION_LINES    : [],
            IsEditing        : false,
        };
    
        // Update state correctly by creating a new array
        setProp(prevState => ({
            ...prevState,
            SESSIONS: [...prevState.SESSIONS, newObject]
        }));
    };

    const moveItem      = useCallback((dragOrder, hoverOrder) => {
        setProp(prevState => {
            const updatedItems = [...prevState.SESSIONS];

            const dragIndex = dragOrder;
            const hoverIndex = hoverOrder;

            if (dragIndex === -1 || hoverIndex === -1 || dragIndex === hoverIndex) {
                return prevState;
            }

            // Remove the dragged item
            const [movedItem] = updatedItems.splice(dragIndex, 1);

            // Insert it at the new position
            updatedItems.splice(hoverIndex, 0, movedItem);

            // After moving, fix all SESSION_ORDER / QUESTION_POSITION
            const reorderedItems = updatedItems.map((item, index) => ({
                ...item,
                SESSION_ORDER: index + 1, // session position
                SESSION_QUESTIONS: item.SESSION_QUESTIONS.map((question, questionIndex) => ({
                    ...question,
                    SESSION_ORDER: index + 1,         // sync with parent
                })),
                SESSION_LINES: item.SESSION_LINES.map((line, lineIndex) => ({
                    ...line,
                    SESSION_ORDER: index + 1, // sync with parent
                })),
            }));

            return {
                ...prevState,
                SESSIONS: reorderedItems,
            };
        });
    }, []);


    function reorderItems () {
        setProp(prevState => {
            const reorderedItems = prevState.SESSIONS.map((item, index) => ({
                ...item,
                SESSION_ORDER: index + 1,
                SESSION_QUESTIONS: item.SESSION_QUESTIONS.map((question, questionIndex) => ({
                    ...question,
                    SESSION_ORDER: index + 1,         // sync with parent
                })),
                SESSION_LINES: item.SESSION_LINES.map((line, lineIndex) => ({
                    ...line,
                    SESSION_ORDER: index + 1, // sync with parent
                })),
            }));
        
            return {
                ...prevState,
                SESSIONS: reorderedItems,
            };
        });
    }
    
    function handleItemDelete(item_position) {
        setProp(prevState => {
            const updatedItems = prevState.SESSIONS.filter(item => item.SESSION_ORDER -1 !== item_position);   
            const reorderedItems = updatedItems.map((item, idx) => ({
                ...item,
                SESSION_ORDER: idx,
            }));    
            return {
                ...prevState,
                SESSIONS: reorderedItems,
            };
        });
        reorderItems();
    }

    const renderItem    = useCallback((mainProp, prop, setProp, index, moveItem) => {
        return (
            <ItemBlock
                key={prop.SESSION_ORDER}
                index={index}
                id={index}
                prop={prop}
                setProp={setProp}
                mainProp={mainProp}
                moveItem={moveItem}
                onDelete={handleItemDelete}
                orderMeta={orderMeta}
            />
        );
    }, []);

    return (
        <>
            <DndProvider backend={backend} options={options}>
        
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.my_3}>
                            {
                                <div>
                                    {
                                        prop?.SESSIONS?.map((item, i) => renderItem(prop,
                                                                                    item, 
                                                                                    setProp, 
                                                                                    i, 
                                                                                    moveItem))
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </DndProvider>
            <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                <div className={MainStyle.col_lg_9}/>
                <div className={MainStyle.col_lg_2}>
                    <div className={MainStyle.mx_3}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_blue, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_7,
                                        MainStyle.text_white,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={addNewItem}
                        >
                            {GetLabel(appLang, 435)}
                        </button>
                    </div>
                </div>
                <div className={MainStyle.col_lg_1}/>
            </div>
            <div className={MainStyle.py_3}/>
        </>
    );

});

const Tab_2 = React.memo(({...other}) => {
    const {prop, setProp, orderMeta} = other;
    return (
        <>
            <ListBlock prop={prop} setProp={setProp} orderMeta={orderMeta}/>
        </>
    );

});
// #endregion

const BtnTab = React.memo(({...other}) => {
    const { prop, setProp, label, type } = other;
    return (
        <>
            <div className={[MainStyle.text_center, MainStyle.mt_2].join(" ")}>
                <button
                    style={{width: '90%'}}
                    className={[prop != type ? MainStyle.btn_vanilla : MainStyle.btn_disabled, 
                                MainStyle.rounded_3, 
                                MainStyle.border, 
                                MainStyle.shadow_sm, 
                                MainStyle.fs_6,
                                MainStyle.py_3,
                                MainStyle.px_2].join(" ")}
                    onClick={() => {
                        if (prop != type) {
                            setProp(type);
                        }
                    }}
                    disabled={prop != type ? false : true}
                >
                    {label}
                </button>
            </div>
        </>
    );
});

const OrderPanel = ({ setProps, data }) => {
    const { showLoader,       hideLoader              }  = useLoader();                // Control over the loader
    const { showInfoMessage                           }  = useInfoMsgModal();          // Modal message control 
    const { showActionMessage                         }  = useActionModal();           // Modal message + action control     
    const { showToastMessage                          }  = useToastMessage();          // Toast message display
    const [ tabType,      setTabType                  ]  = useState(1);                // Tab Type
    const [ orderObj,     setOrderObj                 ]  = useState(blank_order_obj);  // Order object
    const [ metaData,     setMetaData                 ]  = useState(null);

    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_order_obj });
    };

    const BtnExit = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 102)}<br/>{GetLabel(appLang, 103)}</> },
          { confirm_action: () => handleExit()}
        );
    };        

    const handleChange = useCallback((updatedValues) => {
        setOrderObj(prev => {
            const newState = {
                ...prev,
                ...updatedValues
            };
    
            //const hasChange = Object.keys(updatedValues).some(
            //    key => prev[key] !== updatedValues[key]
            //);
            //if (!hasChange) {
            //    console.warn("No actual state change detected");
            //}
    
            return newState;
        });
    });

    function validateRecord(obj) {
        let validation = {
            passed: true,
            messages: []
        };
        if (!compareInitFinDate(obj.OPENING, obj.CLOSING)) {
            validation.passed = false;
            validation.messages.push(GetLabel(appLang, 436));
        }
        if (obj.ORDER_DESC === "" || obj.ORDER_DESC === undefined || obj.ORDER_DESC === null) {
            validation.passed = false;
            validation.messages.push(GetLabel(appLang, 437));
        }
        if (obj.SCHOOL_ID === 0 || obj.SCHOOL_ID === undefined || obj.SCHOOL_ID === null) {
            validation.passed = false;
            validation.messages.push(GetLabel(appLang, 438));
        }
        if (obj.AREA_ID === 0 || obj.AREA_ID === undefined || obj.AREA_ID === null) {
            validation.passed = false;
            validation.messages.push(GetLabel(appLang, 439));
        }
        if (obj.PROGRAM_ID === 0 || obj.PROGRAM_ID === undefined || obj.PROGRAM_ID === null) {
            validation.passed = false;
            validation.messages.push(GetLabel(appLang, 440));
        }
        if (obj.CLIENT_ID === 0 || obj.CLIENT_ID === undefined || obj.CLIENT_ID === null) {
            validation.passed = false;
            validation.messages.push(GetLabel(appLang, 441));
        }
        if (obj.CLASS === "" || obj.CLASS === undefined || obj.CLASS === null) {
            validation.passed = false;
            validation.messages.push(GetLabel(appLang, 442));
        }
        if (obj.PPT_TEMPLATE === 0 || obj.PPT_TEMPLATE === undefined || obj.PPT_TEMPLATE === null) {
            validation.passed = false;
            validation.messages.push(GetLabel(appLang, 443));
        }
        if (obj.PPT_FOOTER === 0 || obj.PPT_FOOTER === undefined || obj.PPT_FOOTER === null) {
            validation.passed = false;
            validation.messages.push(GetLabel(appLang, 444));
        }
        if (obj.COLOR === 0 || obj.COLOR === undefined || obj.COLOR === null) {
            validation.passed = false;
            validation.messages.push(GetLabel(appLang, 445));
        }
        if (obj.EXPLAN_LANG === "Y") {
            if (    (obj.LANG_PT=== "Y"  && (obj.EXPLAN_LANG_PT_DESC === "" || obj.EXPLAN_LANG_PT_DESC === undefined || obj.EXPLAN_LANG_PT_DESC === null))
                ||
                    (obj.LANG_EN === "Y" && (obj.EXPLAN_LANG_EN_DESC === "" || obj.EXPLAN_LANG_EN_DESC === undefined || obj.EXPLAN_LANG_EN_DESC === null))
                ||
                    (obj.LANG_ES === "Y" && (obj.EXPLAN_LANG_ES_DESC === "" || obj.EXPLAN_LANG_ES_DESC === undefined || obj.EXPLAN_LANG_ES_DESC === null))
            ){
                validation.passed = false;
                validation.messages.push(GetLabel(appLang, 446));   
            }
        }
        if (obj.SUBTI_LANG === "Y") {
            if (    (obj.LANG_PT=== "Y"  && (obj.SUBTI_LANG_PT_DESC === "" || obj.SUBTI_LANG_PT_DESC === undefined || obj.SUBTI_LANG_PT_DESC === null))
                ||
                    (obj.LANG_EN === "Y" && (obj.SUBTI_LANG_EN_DESC === "" || obj.SUBTI_LANG_EN_DESC === undefined || obj.SUBTI_LANG_EN_DESC === null))
                ||
                    (obj.LANG_ES === "Y" && (obj.SUBTI_LANG_ES_DESC === "" || obj.SUBTI_LANG_ES_DESC === undefined || obj.SUBTI_LANG_ES_DESC === null))
            ){
                validation.passed = false;
                validation.messages.push(GetLabel(appLang, 447));
            }
        }   
        if (obj.SESSIONS.length == 0 || obj.SESSIONS === undefined || obj.SESSIONS === null ) {
            validation.passed = false;
            validation.messages.push(GetLabel(appLang, 448));
        }
        if (obj.SESSIONS.length > 0) {
            obj.SESSIONS.forEach((session, i) => {
                    if (session.SESSION_DESC === "" || session.SESSION_DESC === undefined || session.SESSION_DESC === null ) {
                        validation.passed = false;
                        validation.messages.push(`${GetLabel(appLang, 449)} ${i + 1}.`);
                    }
                    if (session.ACADEMIC_AREA_ID === 0 || session.ACADEMIC_AREA_ID === undefined || session.ACADEMIC_AREA_ID === null ) {
                        validation.passed = false;
                        validation.messages.push(`${GetLabel(appLang, 450)} ${i + 1}.`);
                    }
                    if (session.SESSION_LINES.length > 0) {
                        session.SESSION_LINES.forEach((session_line, j) => {
                            //5	linha de professor
                            //6	Rótulo e texto
                            if (session_line.TYPE_ID === 5) {
                                if (session_line.USER_ID === 0 || session_line.USER_ID === undefined || session_line.USER_ID === null) {
                                    validation.passed = false;
                                    validation.messages.push(`${GetLabel(appLang, 451)} ${i + 1} ${GetLabel(appLang, 452)} ${j + 1}`);
                                }
                                if (session_line.DESIGNATION_ID === 0 || session_line.DESIGNATION_ID === undefined || session_line.DESIGNATION_ID === null) {
                                    validation.passed = false;
                                    validation.messages.push(`${GetLabel(appLang, 453)} ${i + 1} ${GetLabel(appLang, 452)} ${j + 1}`);
                                }

                            }
                            if (session_line.TYPE_ID === 6) { 
                                if ((obj.LANG_PT === "Y") && 
                                    (
                                        (session_line.LBL_LANG_PT_DESC === "" || session_line.LBL_LANG_PT_DESC === undefined || session_line.LBL_LANG_PT_DESC === null)
                                        &&
                                        (session_line.TXT_LANG_PT_DESC === "" || session_line.TXT_LANG_PT_DESC === undefined || session_line.TXT_LANG_PT_DESC === null)
                                    )
                                ||
                                (obj.LANG_EN === "Y" &&
                                    (
                                        (session_line.LBL_LANG_EN_DESC === "" || session_line.LBL_LANG_EN_DESC === undefined || session_line.LBL_LANG_EN_DESC === null)
                                        &&
                                        (session_line.TXT_LANG_EN_DESC === "" || session_line.TXT_LANG_EN_DESC === undefined || session_line.TXT_LANG_EN_DESC === null)
                                    )
                                )
                                ||
                                (obj.LANG_ES === "Y" &&
                                    (
                                        (session_line.LBL_LANG_ES_DESC === "" || session_line.LBL_LANG_ES_DESC === undefined || session_line.LBL_LANG_ES_DESC === null)
                                        &&
                                        (session_line.TXT_LANG_ES_DESC === "" || session_line.TXT_LANG_ES_DESC === undefined || session_line.TXT_LANG_ES_DESC === null)
                                    )
                                )
                                    ){
                                    validation.passed = false;
                                    validation.messages.push(`${GetLabel(appLang, 454)} ${i + 1} ${GetLabel(appLang, 452)} ${j + 1}`);
                                }
                            }

                        });
                    }
                    if (session.SESSION_QUESTIONS.length > 0) {
                        session.SESSION_QUESTIONS.forEach((session_question, j) => {
                            let question = metaData.ORDER_SETTINGS.QUESTIONS.find((question) => {
                                if (question.QUESTION_ID === session_question.QUESTION_ID) {
                                    return (question);
                                }
                            });
                            if (question) {
                                if ((obj.LANG_PT === "Y") && (question.LANG_PT === "N")) {
                                    validation.passed = false;
                                    validation.messages.push(`${GetLabel(appLang, 455)} ${question.QUESTION_DESC} ${GetLabel(appLang, 456)} ${i + 1} ${GetLabel(appLang, 457)}  ${j + 1}, ${GetLabel(appLang, 458)}`);
                                }
                                if ((obj.LANG_EN === "Y") && (question.LANG_EN === "N")) {
                                    validation.passed = false;
                                    validation.messages.push(`${GetLabel(appLang, 455)} ${question.QUESTION_DESC} ${GetLabel(appLang, 456)} ${i + 1} ${GetLabel(appLang, 457)}  ${j + 1}, ${GetLabel(appLang, 459)}`);
                                }
                                if ((obj.LANG_ES === "Y") && (question.LANG_ES === "N")) {
                                    validation.passed = false;
                                    validation.messages.push(`${GetLabel(appLang, 455)} ${question.QUESTION_DESC} ${GetLabel(appLang, 456)} ${i + 1} ${GetLabel(appLang, 457)} ${j + 1}, ${GetLabel(appLang, 460)}`);
                                }
                            }

                        });
                    }
                    if (session.SESSION_QUESTIONS.length === 0) {
                        validation.passed = false;
                        validation.messages.push(GetLabel(appLang, 448));
                    }
            });

        }
        return validation;
    }
    
    async function closeOrder() {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await closeOrderByID(orderObj.ORDER_ID);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                stateManager({
                    setObjectState: handleChange,
                    objectValue: {
                        STATUS_ID: 5,
                        CLOSING: DateToIsoString(dayjs()),
                    }
                });
                hideLoader();
                showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 461)});
            }
            else {
                hideLoader();
                showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData.status.message});
            }
        }
    }

    const handleSave = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let order_data     = orderObj;
        if (order_data.STATUS_ID === 5) {
            let c = dayjs();
            let f = DateFromIsoString(order_data.CLOSING);
            if (c < f) {
                order_data.STATUS_ID = 4;
            }
        }
        let fetchedData    = await updateOrder(order_data);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 106)});
                fetchedData = fetchedData.response.content;
                setOrderObj(prev => {
                    const newState = {
                        ...prev,
                        ORDER_ID: fetchedData.ORDER_ID,
                        ORDER_CODE: fetchedData.ORDER_CODE,
                        QRCODE: fetchedData.QRCODE,
                        QRCODE_DATA: fetchedData.QRCODE_DATA,
                        QRCODEP: fetchedData.QRCODEP,
                        QRCODEP_DATA: fetchedData.QRCODEP_DATA,
                        PPT: fetchedData.PPT,
                        PPT_DATA: fetchedData.PPT_DATA
                    };
                    return newState;
                });

            }
            else {
                hideLoader();
                showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData.status.message});
            }
        }
    };

    const handleDelete = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await deleteOrder(orderObj.ORDER_ID);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                setProps({ setScreen: 1, data: blank_order_obj });   
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleRegenFiles = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await regenFiles(orderObj.ORDER_ID);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 106)});
                fetchedData = fetchedData.response.content;
                setOrderObj(prev => {
                    const newState = {
                        ...prev,
                        QRCODE: fetchedData.QRCODE,
                        QRCODE_DATA: fetchedData.QRCODE_DATA,
                        QRCODEP: fetchedData.QRCODEP,
                        QRCODEP_DATA: fetchedData.QRCODEP_DATA,
                        PPT: fetchedData.PPT,
                        PPT_DATA: fetchedData.PPT_DATA
                    };
                    return newState;
                });

            }
            else {
                hideLoader();
                showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData.status.message});
            }
        }        
    };

    const handleSaveNotification = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await updateOrderNotification(orderObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 106)});
                fetchedData = fetchedData.response.content;
                setOrderObj(prev => {
                    const newState = {
                        ...prev,
                        ORDER_ID: fetchedData.ORDER_ID,
                        ORDER_CODE: fetchedData.ORDER_CODE,
                        QRCODE: fetchedData.QRCODE,
                        QRCODE_DATA: fetchedData.QRCODE_DATA,
                        QRCODEP: fetchedData.QRCODEP,
                        QRCODEP_DATA: fetchedData.QRCODEP_DATA,
                        PPT: fetchedData.PPT,
                        PPT_DATA: fetchedData.PPT_DATA
                    };
                    return newState;
                });

            }
            else {
                hideLoader();
                showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData.status.message});
            }
        }
    };    

    const BtnSave = () => {
        const validationObject = validateRecord(orderObj);    
        if (validationObject.passed === true) {
            showActionMessage(
                { header: GetLabel(appLang, 54), message: GetLabel(appLang, 462) },
                { confirm_action: () => handleSave()}
            );
        }
        else {
            showInfoMessage(
                { header: GetLabel(appLang, 54), 
                  message: (
                    <>
                      {GetLabel(appLang, 185)}<br/>
                      {GetLabel(appLang, 463)}<br/>
                      {
                          <div className={[MainStyle.bg_warning, MainStyle.text_wrap, MainStyle.me_2].join(" ")}>
                                <div className={[MainStyle.ms_1].join(" ")}>
                                {
                                  validationObject.messages.map((msg, i) => (
                                      <React.Fragment key={i}>
                                        <div className={MainStyle.border_bottom}>
                                            <span className={[MainStyle.text_black, MainStyle.fs_7, MainStyle.my_3,].join(" ")}>
                                                {i + 1} : {msg}<br/>
                                            </span>
                                        </div>
                                      </React.Fragment>
                                  ))
                                }
                                </div>
                          </div>
                      }

                    </>
                  )
                }
            );
            return;

        }
    };

    const BtnDelete = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 464) },
          { confirm_action: () => handleDelete()}
        );
    };

    const BtnSaveNotify = () => {
        const validationObject = validateRecord(orderObj);    
        if (validationObject.passed === true) {
            showActionMessage(
                { header: GetLabel(appLang, 54), message: GetLabel(appLang, 465) },
                { confirm_action: () => handleSaveNotification()}
            );
        }
        else {
            showInfoMessage(
                { header: GetLabel(appLang, 54), 
                  message: (
                    <>
                      {GetLabel(appLang, 185)}<br/>
                      {GetLabel(appLang, 463)}<br/>
                      {
                          <div className={[MainStyle.bg_warning, MainStyle.text_wrap, MainStyle.me_2].join(" ")}>
                                <div className={[MainStyle.ms_1].join(" ")}>
                                {
                                  validationObject.messages.map((msg, i) => (
                                      <React.Fragment key={i}>
                                        <div className={MainStyle.border_bottom}>
                                            <span className={[MainStyle.text_black, MainStyle.fs_7, MainStyle.my_3,].join(" ")}>
                                                {i + 1} : {msg}<br/>
                                            </span>
                                        </div>
                                      </React.Fragment>
                                  ))
                                }
                                </div>
                          </div>
                      }

                    </>
                  )
                }
            );
            return;

        }
    };

    const handleStatusChange = async (desired_id) => {
        if (desired_id == 6) {
            showActionMessage(
                { header: GetLabel(appLang, 54), message: GetLabel(appLang, 466) },
                { confirm_action: async () => {
                        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0) });
                        let fetchedData = await updateOrderStatus(orderObj.ORDER_ID, desired_id);
                        if (fetchedData) {
                            if (fetchedData?.status?.statusCode == 0) {
                                hideLoader();
                                showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 468) });
                                setOrderObj(prev => {                                
                                    return({...prev,STATUS_ID: desired_id});
                                });

                            }
                            else {
                                hideLoader();
                                showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData.status.message});
                            }
                        }
                }}
            );
        }
        else if (desired_id == 3) {
            showActionMessage(
                { header: GetLabel(appLang, 54), message: GetLabel(appLang, 467) },
                { confirm_action: async () => {
                        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0) });
                        let fetchedData = await updateOrderStatus(orderObj.ORDER_ID, desired_id);
                        if (fetchedData) {
                            if (fetchedData?.status?.statusCode == 0) {
                                hideLoader();
                                showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 468)});
                                setOrderObj(prev => {                                
                                    return({...prev,STATUS_ID: desired_id});
                                });

                            }
                            else {
                                hideLoader();
                                showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData.status.message});
                            }
                        }
                }}
            );
        }
        else if (desired_id == 4) {
            showActionMessage(
                { header: GetLabel(appLang, 54), message: GetLabel(appLang, 469) },
                { confirm_action: async () => {
                        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0) });
                        let fetchedData = await updateOrderStatus(orderObj.ORDER_ID, desired_id);
                        if (fetchedData) {
                            if (fetchedData?.status?.statusCode == 0) {
                                hideLoader();
                                showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 468) });
                                setOrderObj(prev => {                                
                                    return({...prev,STATUS_ID: desired_id});
                                });

                            }
                            else {
                                hideLoader();
                                showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData.status.message});
                            }
                        }
                }}
            );
        }
        else {
            showActionMessage(
                { header: GetLabel(appLang, 54), message: GetLabel(appLang, 470) },
                { confirm_action: async () => {
                        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0) });
                        let fetchedData = await updateOrderStatus(orderObj.ORDER_ID, desired_id);
                        if (fetchedData) {
                            if (fetchedData?.status?.statusCode == 0) {
                                hideLoader();
                                showToastMessage({header: GetLabel(appLang, 14), message: GetLabel(appLang, 468) });
                                setOrderObj(prev => {                                
                                    return({...prev,STATUS_ID: desired_id});
                                });

                            }
                            else {
                                hideLoader();
                                showInfoMessage({header: GetLabel(appLang, 107), message: fetchedData.status.message});
                            }
                        }
                }}
            );
        }
    };

    const BtnRegenFiles = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 471) },
          { confirm_action: () => handleRegenFiles()}
        );
    };    

    const BtnClose = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 472) },
          { confirm_action: () => closeOrder()}
        );
    };

    useEffect(() => {
        let isMounted = true;
    
        const fetchAll = async () => {
            showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0) });
    
            let metaSuccess = false;
            let dataSuccess = true;
    
            try {
                const metaResponse = await getOrderMeta();
    
                const isMetaSuccess = metaResponse?.status?.statusCode === 0;
                const hasMetaContent = metaResponse?.response?.content;
    
                if (isMounted && isMetaSuccess && hasMetaContent) {
                    setMetaData(metaResponse.response.content);
                    metaSuccess = true;
                }
    
                if (!isMetaSuccess) {
                    showInfoMessage({
                        header: GetLabel(appLang, 107),
                        message: metaResponse?.status?.message || "Unknown error in metadata",
                    });
                }
    
                // Proceed to fetch order data only if meta succeeded and ORDER_ID is not 0
                if (isMetaSuccess && data?.ORDER_ID && data.ORDER_ID !== 0) {
                    try {
                        const orderResponse = await getOrderByID(data.ORDER_ID);
                        const isOrderSuccess = orderResponse?.status?.statusCode === 0;
                        const orderContent = orderResponse?.response?.content;
    
                        if (isMounted && isOrderSuccess && orderContent) {
                            const content = orderContent;
    
                            // Assign LOGO DATA
                            if (Array.isArray(metaResponse.response.content?.ORDER_SETTINGS?.LOGOS)) {
                                for (let logo of metaResponse.response.content.ORDER_SETTINGS.LOGOS) {
                                    if (content.LOGO1 !== 0 && content.LOGO1 === logo.FILE_ID) {
                                        content.LOGO1_DATA = logo.FILE_DATA;
                                    }
                                    if (content.LOGO2 !== 0 && content.LOGO2 === logo.FILE_ID) {
                                        content.LOGO2_DATA = logo.FILE_DATA;
                                    }
                                    if (content.LOGO3 !== 0 && content.LOGO3 === logo.FILE_ID) {
                                        content.LOGO3_DATA = logo.FILE_DATA;
                                    }
                                }
                            }
    
                            for (let i = 0; i < content.SESSIONS.length; i++) {
                                content.SESSIONS[i].IsEditing = false;
                            }
    
                            setOrderObj(content);
                            dataSuccess = true;
                        } else {
                            dataSuccess = false;
                        }
                    } catch (err) {
                        dataSuccess = false;
                        if (isMounted) {
                            setOrderObj(blank_order_obj);
                        }
                    }
                }
            } catch (err) {
                metaSuccess = false;
            } finally {
                if (metaSuccess && dataSuccess && isMounted) {
                    hideLoader();
                }
            }
        };
    
        fetchAll();
    
        return () => {
            isMounted = false;
        };
    }, [data]);
    
    return(
        <>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>                
                <CloseObj handleExit={BtnExit}/>

                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>

                    <div className={MainStyle.mt_3}/>
                    
                    {/*             Main Label              */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.mx_3}>
                                <span className={[MainStyle.fs_5,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                                    {GetLabel(appLang, 473)}
                                </span>
                                <span className={[MainStyle.fs_4,MainStyle.text_info,   MainStyle.text_wrap, MainStyle.fw_semibold].join(" ")}>
                                    {orderObj.ORDER_DESC}                                   
                                </span>
                            </div>
                        </div>
                        {(orderObj.ORDER_ID != 0 && orderObj.ORDER_CODE != "") && (
                            <div className={MainStyle.col_lg}>
                                <div className={MainStyle.mx_3}>
                                    <span className={[MainStyle.fs_5,MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                                        {GetLabel(appLang, 474)}
                                    </span>
                                    <span className={[MainStyle.fs_4,MainStyle.text_info,   MainStyle.text_wrap, MainStyle.fw_semibold].join(" ")}>
                                        {orderObj.ORDER_CODE}                                   
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>

                    {/*     List of options buttons row     */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_3}/>
                        <div className={MainStyle.col_lg_2}>
                            <BtnTab prop={tabType} setProp={setTabType} label={GetLabel(appLang, 496)}        type={1}/>
                        </div>
                        <div className={MainStyle.col_lg_2}>
                            <BtnTab prop={tabType} setProp={setTabType} label={GetLabel(appLang, 497)}    type={2}/>
                        </div>
                        <div className={MainStyle.col_lg_2}>
                            <BtnTab prop={tabType} setProp={setTabType} label={GetLabel(appLang, 498)} type={3}/>
                        </div>
                        <div className={MainStyle.col_lg_3}/>
                    </div>                    
                    <DefaultPadding/>
                    <DivisionBlock/>
                    <DefaultPadding/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.mx_3}>
                            {
                                tabType == 1?
                                    <Tab_0 prop={orderObj} setProp={handleChange} orderMeta={metaData}/>
                                :
                                tabType == 2?
                                    <Tab_1 prop={orderObj} setProp={handleChange} orderMeta={metaData}/>
                                :
                                tabType == 3?
                                    <Tab_2 prop={orderObj} setProp={setOrderObj} orderMeta={metaData}/>
                                :
                                    null
                            }
                            </div>
                        </div>
                    </div>
                </div>
                <DefaultPadding/>          
                {/*--------------------------------------------------------------------------*/}                  
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.mx_3}>
                        {DavidCopperfield(14,89,6) && (
                            orderObj.ORDER_ID != 0 ? 
                                <div className={[MainStyle.mt_3].join(" ")}>
                                    <button
                                        style={{width: '100%'}}
                                        className={[MainStyle.btn_delete, 
                                                    MainStyle.rounded_3, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.py_3,
                                                    MainStyle.px_3].join(" ")}
                                        onClick={() => {BtnDelete();}}
                                    >
                                        {GetLabel(appLang, 114)}
                                    </button>
                                </div>
                        : 
                            null
                        )}
                        </div>
                    </div>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.mx_3}>
                        {DavidCopperfield(14,89,4) && (
                            orderObj.ORDER_ID != 0 && (orderObj.STATUS_ID == 3 || orderObj.STATUS_ID == 4 || orderObj.STATUS_ID == 5) ?
                                <div className={[MainStyle.mt_3].join(" ")}>
                                    <button
                                        style={{width: '100%'}}
                                        className={[MainStyle.btn_delete, 
                                                    MainStyle.rounded_3, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.py_3,
                                                    MainStyle.px_3].join(" ")}
                                        onClick={() => {handleStatusChange(6);}}
                                    >
                                        {GetLabel(appLang, 475)}
                                    </button>
                                </div>
                            : 
                            orderObj.ORDER_ID != 0 && orderObj.STATUS_ID == 6 ?
                                <div className={[MainStyle.mt_3].join(" ")}>
                                    <button
                                        style={{width: '100%'}}
                                        className={[MainStyle.btn_blue, 
                                                    MainStyle.rounded_3, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.py_3,
                                                    MainStyle.px_3,
                                                    MainStyle.text_white].join(" ")}
                                        onClick={() => {handleStatusChange(3);}}
                                    >
                                        {GetLabel(appLang, 476)}
                                    </button>
                                </div>
                            :
                                null
                        )}
                        </div>
                    </div>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.mx_3}>
                        {DavidCopperfield(14,89,4) && (
                            orderObj.ORDER_ID != 0 && (
                                <div className={[MainStyle.mt_3].join(" ")}>
                                    <button
                                        style={{width: '100%'}}
                                        className={[MainStyle.btn_blue, 
                                                    MainStyle.rounded_3, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.py_3,
                                                    MainStyle.px_3,
                                                    MainStyle.text_white].join(" ")}
                                        onClick={() => {BtnRegenFiles();}}
                                    >
                                        {GetLabel(appLang, 477)}
                                    </button>
                                </div>
                        ))}
                        </div>
                    </div>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.mx_3}>
                        {DavidCopperfield(14,89,4) && (
                            orderObj.ORDER_ID != 0 && orderObj.STATUS_ID == 3 ?
                                <div className={[MainStyle.mt_3].join(" ")}>
                                    <button
                                        style={{width: '100%'}}
                                        className={[MainStyle.btn_blue, 
                                                    MainStyle.rounded_3, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.py_3,
                                                    MainStyle.px_3,
                                                    MainStyle.text_white].join(" ")}
                                        onClick={() => {handleStatusChange(4);}}
                                    >
                                        {GetLabel(appLang, 478)}
                                    </button>
                                </div>
                            : 
                            orderObj.ORDER_ID != 0 && orderObj.STATUS_ID == 4 ?
                                <div className={[MainStyle.mt_3].join(" ")}>
                                    <button
                                        style={{width: '100%'}}
                                        className={[MainStyle.btn_blue, 
                                                    MainStyle.rounded_3, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.py_3,
                                                    MainStyle.px_3,
                                                    MainStyle.text_white].join(" ")}
                                        onClick={() => {handleStatusChange(3);}}
                                    >
                                        {GetLabel(appLang, 29)}
                                    </button>
                                </div> 
                            :
                            orderObj.ORDER_ID != 0 && orderObj.STATUS_ID == 5 ?
                                <div className={[MainStyle.mt_3].join(" ")}>
                                    <button
                                        style={{width: '100%'}}
                                        className={[MainStyle.btn_blue, 
                                                    MainStyle.rounded_3, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.py_3,
                                                    MainStyle.px_3,
                                                    MainStyle.text_white].join(" ")}
                                        onClick={() => {handleStatusChange(4);}}
                                    >
                                        {GetLabel(appLang, 478)}
                                    </button>
                                </div>                                                                                        
                            :
                                null
                        )}
                        </div>
                    </div>
                    <div className={MainStyle.col_lg}>
                        {DavidCopperfield(14,89,4) && (
                            orderObj.ORDER_ID != 0 && orderObj.STATUS_ID == 4 && (
                            <div className={MainStyle.mx_3}>
                                <div className={[MainStyle.mt_3].join(" ")}>
                                    <button
                                        style={{width: '100%'}}
                                        className={[MainStyle.btn_blue, 
                                                    MainStyle.rounded_3, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.py_3,
                                                    MainStyle.px_3,
                                                    MainStyle.text_white].join(" ")}
                                        onClick={() => {BtnClose();}}
                                    >
                                        {GetLabel(appLang, 479)}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className={MainStyle.col_lg}>
                        {DavidCopperfield(14,89,4) && (                                            
                            orderObj.ORDER_ID != 0 ? 
                                <div className={MainStyle.mx_3}>
                                    <div className={[MainStyle.mt_3].join(" ")}>
                                        <button
                                            style={{width: '100%'}}
                                            className={[MainStyle.btn_blue, 
                                                        MainStyle.rounded_3, 
                                                        MainStyle.border, 
                                                        MainStyle.shadow_sm, 
                                                        MainStyle.fs_6,
                                                        MainStyle.py_3,
                                                        MainStyle.px_3].join(" ")}
                                            onClick={() => {BtnSaveNotify();}}
                                        >
                                            <span className={MainStyle.text_white}>
                                                {GetLabel(appLang, 480)}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            : 
                                null
                        )}
                    </div>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.mx_3}>
                        {DavidCopperfield(14,89,4) && (
                            orderObj.ORDER_ID != 0  && orderObj.PPT_DATA != "" ? 
                                <div className={[MainStyle.mt_3].join(" ")}>
                                    <a href={getFileTmpSrc(orderObj.PPT_DATA)} download={`${toSafeFilename(orderObj.ORDER_DESC)}.pptx`}>
                                        <button
                                            style={{width: '100%'}}
                                            className={[MainStyle.btn_blue, 
                                                        MainStyle.rounded_3, 
                                                        MainStyle.border, 
                                                        MainStyle.shadow_sm, 
                                                        MainStyle.fs_6,
                                                        MainStyle.py_3,
                                                        MainStyle.px_3].join(" ")}
                                        >
                                            <span className={MainStyle.text_white}>
                                                {GetLabel(appLang, 481)}
                                            </span>
                                        </button>
                                    </a>
                                </div>
                        : 
                            null
                        )}
                        </div>
                    </div>
                    <div className={MainStyle.col_lg}>
                        {DavidCopperfield(14,89,4) && (
                            <div className={MainStyle.mx_3}>
                                <div className={[MainStyle.mt_3].join(" ")}>
                                    <button
                                        style={{width: '100%'}}
                                        className={[MainStyle.btn_green, 
                                                    MainStyle.rounded_3, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.text_white,
                                                    MainStyle.py_3,
                                                    MainStyle.px_3].join(" ")}
                                        onClick={() => {BtnSave();}}
                                    >
                                        {GetLabel(appLang, 49)}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/*--------------------------------------------------------------------------*/}
                <DefaultPadding/>
            </div>
        </>
    );

};

const FilterOptions = React.memo(({...props}) => {
    const { showInfoMessage             }      = useInfoMsgModal();
    const { showLoader,  hideLoader     }      = useLoader();
    const [ searchType,  setSearchType  ]      = useState(1);
    const { setRowData,  
            filterMeta,
            searchParam,    
            setSearchParam              }      = props;
    
    const statusListReduced                     =  [{value: 3, label: GetLabel(appLang, 29)},
                                                    {value: 4, label: GetLabel(appLang, 99)},
                                                    {value: 5, label: GetLabel(appLang, 482)}];
    const statusList                             =  [{value: 3, label: GetLabel(appLang, 29)},
                                                     {value: 4, label: GetLabel(appLang, 99)},
                                                     {value: 5, label: GetLabel(appLang, 97)},
                                                     {value: 6, label: GetLabel(appLang, 232)}];                                                

    async function startSearch() {
        if (searchType === 1) {
            showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
            let data = await getOrdersList(searchParam);
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    let arr = [];
                    for(var j = 0; j < data.length; j++) {
                        arr.push(data[j]);
                    }
                    setRowData(arr);
                    hideLoader();
                }
                else {
                    hideLoader();
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }            

        }
        else if (searchType === 2) {
            if ((searchParam.DT_INIT === null) && (searchParam.DT_FN === null)) {
                showInfoMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 483)});
                return;
            }
            if (!compareInitFinDate(searchParam.DT_INIT, searchParam.DT_FN)) {
                showInfoMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 230)});
                return;
            }
            showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
            let data = await getParamOrdersList(searchParam);
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    let arr = [];
                    for(var j = 0; j < data.length; j++) {
                        arr.push(data[j]);
                    }
                    setRowData(arr);
                    hideLoader();
                }
                else {
                    hideLoader();
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }            
            
        }
        else {
            showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
            let data = await getOrdersList(searchParam);
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    let arr = [];
                    for(var j = 0; j < data.length; j++) {
                        arr.push(data[j]);
                    }
                    setRowData(arr);
                    hideLoader();
                }
                else {
                    hideLoader();
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }
        }
    }

    function getAvailableStatus() {
        for (let i = 0; i < statusListReduced.length; i++) {
            if (statusListReduced[i].value === searchParam?.STATUS_ID[0]) {
                return (statusListReduced[i].value);
            }
        }
        return (3);
    }
    
    function statusRedChange(d) {
        if (d === 5) {
            setSearchParam(prev => {
                return({
                    ...prev,
                    STATUS_ID: prev.STATUS_ID.map((status, i) =>
                        i === 0 ?
                            d
                        :
                            status
                    ),
                    DT_INIT: DateToIsoString(dayjs().subtract(10 ,'day').set('hour', 0).set('minute', 0).set('second', 0)),
                    DT_FN: DateToIsoString(dayjs().set('hour', 23).set('minute', 59).set('second', 59))
                })
            });
        }
        else {
            setSearchParam(prev => {
                return({
                    ...prev,
                    STATUS_ID: prev.STATUS_ID.map((status, i) =>
                        i === 0 ?
                            d
                        :
                            status
                    ),
                    DT_INIT: null,
                    DT_FN: null
                })
            });
        }
    }
    useEffect(() => {
    }, [searchParam]);

    return(
        <>
            <div className={[MainStyle.row, MainStyle.pb_3].join(" ")}>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_vanilla, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.text_body,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={async () => {
                                setSearchParam(prev => {
                                    return({
                                        ...prev,
                                        DT_INIT: null,
                                        DT_FN: null,
                                    });
                                });
                                setSearchType(1);
                            }}
                        >
                            {GetLabel(appLang, 484)}
                        </button>
                    </div>
                </div>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_vanilla, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.text_body,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={async () => {setSearchType(2);}}
                        >
                            {GetLabel(appLang, 485)}
                        </button>
                    </div>                    
                </div>

            </div>
            {  searchType === 1 ?
                <>
                    <div className={[MainStyle.py_1].join(" ")}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                                    <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                        {GetLabel(appLang, 486)}
                                    </span>
                                    <DropdownList
                                        value={getAvailableStatus()}
                                        placeholder={GetLabel(appLang, 233)}
                                        listOfItems={statusListReduced}
                                        style={{ width: "100%" }}
                                        className={[MainStyle.mt_2].join(" ")}
                                        onChange={(event) => {
                                            statusRedChange(event);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={[MainStyle.border_top, MainStyle.py_3].join(" ")}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                                    <button
                                        style={{width: '100%'}}
                                        className={[MainStyle.btn_green, 
                                                    MainStyle.rounded_3, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.text_white,
                                                    MainStyle.py_3,
                                                    MainStyle.px_3].join(" ")}
                                        onClick={async () => {startSearch();}}
                                    >
                                        {GetLabel(appLang, 238)}
                                    </button>
                                </div>
                            </div>                            
                        </div>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                                    <button
                                        style={{width: '100%'}}
                                        className={[MainStyle.btn_vanilla, 
                                                    MainStyle.rounded_3, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.text_body,
                                                    MainStyle.py_3,
                                                    MainStyle.px_3].join(" ")}
                                        onClick={async () => {
                                            setSearchParam(prev => {
                                                return({
                                                    ...prev,
                                                    SCHOOL_ID: null,
                                                    AREA_ID: null,
                                                    PROGRAM_ID: null,
                                                    CLIENT_ID: null,
                                                    DT_INIT: null,
                                                    DT_FN: null,
                                                    STATUS_ID: prev.STATUS_ID.map((status, i) =>
                                                        i === 0 ?
                                                            3
                                                        :
                                                            status
                                                    )

                                                });
                                            });
                                        }}
                                    >
                                        {GetLabel(appLang, 239)}
                                    </button>
                                </div>
                            </div>                            
                        </div>
                    </div>
                </>

            : 
                searchType === 2 ?
                <>
                    <div className={[MainStyle.overflow_y_scroll, MainStyle.py_1].join(" ")}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                                    <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                        {GetLabel(appLang, 37)}
                                    </span>
                                    <DropdownList
                                        value={searchParam?.STATUS_ID[0] || [3]}
                                        placeholder={GetLabel(appLang, 233)}
                                        listOfItems={statusList}
                                        style={{ width: "100%" }}
                                        className={[MainStyle.mt_2].join(" ")}
                                        onChange={(event) => {
                                            setSearchParam(prev => {
                                                return({
                                                    ...prev,
                                                    STATUS_ID: prev.STATUS_ID.map((status, i) =>
                                                        i === 0 ?
                                                            event
                                                        :
                                                            status
                                                    )
                                                })
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                                    <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                        {GetLabel(appLang, 318)}
                                    </span>
                                    <DropdownList
                                        value={searchParam ? searchParam.SCHOOL_ID !== null ? searchParam.SCHOOL_ID : null : null}
                                        placeholder={GetLabel(appLang, 379)}
                                        listOfItems={ 
                                            filterMeta?.SCHOOL_LIST.map((i) => (
                                                    {value: i.SCHOOL_ID, label: i.SCHOOL_DESC}
                                                ))
                                        }
                                        style={{ width: "100%" }}
                                        className={[MainStyle.mt_2].join(" ")}
                                        onChange={(event) => {
                                            const data = event === undefined ? null : event;
                                            setSearchParam(prev => {
                                                return({
                                                    ...prev,
                                                    SCHOOL_ID: data
                                                });
                                            });

                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                                    <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                        {GetLabel(appLang, 319)}
                                    </span>
                                    <DropdownList
                                        value={searchParam ? searchParam.AREA_ID !== null ? searchParam.AREA_ID : null : null}
                                        placeholder={GetLabel(appLang, 380)}
                                        listOfItems={ 
                                            filterMeta?.AREA_LIST.map((i) => (
                                                    {value: i.AREA_ID, label: i.AREA_DESC}
                                                ))
                                        }
                                        style={{ width: "100%" }}
                                        className={[MainStyle.mt_2].join(" ")}
                                        onChange={(event) => {
                                            const data = event === undefined ? null : event;
                                            setSearchParam(prev => {
                                                return({
                                                    ...prev,
                                                    AREA_ID: data
                                                });
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                                    <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                        {GetLabel(appLang, 321)}
                                    </span>
                                    <DropdownList
                                        value={searchParam ? searchParam.PROGRAM_ID !== null ? searchParam.PROGRAM_ID : null : null}
                                        placeholder={GetLabel(appLang, 381)}
                                        listOfItems={ 
                                            filterMeta?.PROGRAM_LIST.map((i) => (
                                                    {value: i.PROGRAM_ID, label: i.PROGRAM_DESC}
                                                ))
                                        }
                                        style={{ width: "100%" }}
                                        className={[MainStyle.mt_2].join(" ")}
                                        onChange={(event) => {
                                            const data = event === undefined ? null : event;
                                            setSearchParam(prev => {
                                                return({
                                                    ...prev,
                                                    PROGRAM_ID: data
                                                });
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                                    <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                        {GetLabel(appLang, 322)}
                                    </span>
                                    <DropdownList
                                        value={searchParam ? searchParam.CLIENT_ID !== null ? searchParam.CLIENT_ID : null : null}
                                        placeholder={GetLabel(appLang, 382)}
                                        listOfItems={ 
                                            filterMeta?.CLIENT_LIST.map((i) => (
                                                    {value: i.CLIENT_ID, label: i.CLIENT_DESC}
                                                ))
                                        }
                                        style={{ width: "100%" }}
                                        className={[MainStyle.mt_2].join(" ")}
                                        onChange={(event) => {
                                            const data = event === undefined ? null : event;
                                            setSearchParam(prev => {
                                                return({
                                                    ...prev, 
                                                    CLIENT_ID: data
                                                });
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>                                                                        
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                                    <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                        {GetLabel(appLang, 487)}
                                    </span>                      
                                    <DatePicker
                                        value={
                                            searchParam ? 
                                                searchParam.DT_INIT !== null ?
                                                    InitDateFromIsoString(searchParam.DT_INIT)
                                                :
                                                    null
                                            : 
                                                null
                                        }
                                        placeholder={GetLabel(appLang, 487)}
                                        style={{ width: "100%" }}
                                        className={[MainStyle.mt_2].join(" ")}
                                        onChange={(date) => {
                                            const data = date === undefined ? DateToIsoString(setDefaultInitDate()) : date;
                                            setSearchParam(prev => {
                                                return({
                                                    ...prev,
                                                    DT_INIT: InitDateToIsoString(data),
                                                });
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                                    <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                        {GetLabel(appLang, 488)}
                                    </span>
                                    <DatePicker
                                        value={
                                            searchParam ? 
                                                searchParam.DT_FN !== null ?
                                                    FinDateFromIsoString(searchParam.DT_FN)
                                                :
                                                    null
                                            : 
                                                null
                                        }
                                        placeholder={GetLabel(appLang, 488)}
                                        style={{ width: "100%" }}
                                        className={[MainStyle.mt_2].join(" ")}
                                        onChange={(date) => {
                                            const data = date === undefined ? DateToIsoString(setDefaultFinalDate()) : date;
                                            setSearchParam(prev => {
                                                return({
                                                    ...prev,
                                                    DT_FN: FinDateToIsoString(data),
                                                });
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={[MainStyle.border_top, MainStyle.py_3].join(" ")}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                                    <button
                                        style={{width: '100%'}}
                                        className={[MainStyle.btn_green, 
                                                    MainStyle.rounded_3, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.text_white,
                                                    MainStyle.py_3,
                                                    MainStyle.px_3].join(" ")}
                                        onClick={async () => {startSearch();}}
                                    >
                                        {GetLabel(appLang, 238)}
                                    </button>
                                </div>
                            </div>                            
                        </div>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg}>
                                <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                                    <button
                                        style={{width: '100%'}}
                                        className={[MainStyle.btn_vanilla, 
                                                    MainStyle.rounded_3, 
                                                    MainStyle.border, 
                                                    MainStyle.shadow_sm, 
                                                    MainStyle.fs_6,
                                                    MainStyle.text_body,
                                                    MainStyle.py_3,
                                                    MainStyle.px_3].join(" ")}
                                        onClick={async () => {
                                            setSearchParam(prev => {
                                                return({
                                                    ...prev,
                                                    SCHOOL_ID: null,
                                                    AREA_ID: null,
                                                    PROGRAM_ID: null,
                                                    CLIENT_ID: null,
                                                    DT_INIT: DateToIsoString(setDefaultInitDate()),
                                                    DT_FN: DateToIsoString(setDefaultFinalDate()),
                                                    STATUS_ID: prev.STATUS_ID.map((status, i) =>
                                                        i === 0 ?
                                                            3
                                                        :
                                                            status
                                                    )

                                                });
                                            });
                                        }}
                                    >
                                        {GetLabel(appLang, 239)}
                                    </button>
                                </div>
                            </div>                            
                        </div>
                    </div>
                </>                                    
            : 
            null}
        </>
    );

});

const FilterPanel = React.memo(({...props}) => {
    const { setRowData      }       = props;
    const [ expanded, setExpanded] = useState(false);
    const [ height,   setHeight]   = useState(0);
    const [ overFlow, setOverFlow] = useState("hidden");
    const intervalRef              = useRef(null);

    const handleClick = () => {
        if (intervalRef.current) return;

        if (!expanded) {
          setExpanded(true);
          intervalRef.current = setInterval(() => {
            setHeight(prev => {
              if (prev >= 100) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
                return 100;
              }
              return prev + 1;
            });
            setOverFlow("scroll");
          }, 5);
        } else {
          intervalRef.current = setInterval(() => {
            setHeight(prev => {
              if (prev <= 0) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
                setExpanded(false); // Close only after animation ends
                return 0;
              }
              return prev - 1;
            });
            setOverFlow("hidden");
          }, 5);
        }
    };
    return (
        <>        
            { 
                expanded ?
                    <>
                        <div className={[MainStyle.bg_card_item, MainStyle.shadow_sm, MainStyle.border, MainStyle.rounded].join(" ")}>
                            <div className={[MainStyle.d_flex, MainStyle.bg_header_item, MainStyle.rounded_top].join(" ")}>
                                    <div className={[ MainStyle.align_self_center]}>
                                        <span className={[MainStyle.mx_3, MainStyle.text_white, MainStyle.fs_5, MainStyle.fw_semibold].join(" ")}>
                                            Filtros
                                        </span> 
                                    </div>
                                    <div className={[MainStyle.ms_auto].join(" ")}>
                                        <div 
                                            onClick={() => {handleClick();}}
                                            className={[MainStyle.shadow_sm, MainStyle.rounded_top, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_3, MainStyle.ms_1].join(" ")}>
                                            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                                <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                                            </svg>
                                        </div>
                                    </div>
                            </div>
                            <div 
                                style={{
                                   height: `${Math.floor(height / 8.0)}rem`,
                                   overflowY: `${overFlow}`,
                                   transition: 'height 0.1s linear',
                                 }}
                            >
                                <FilterOptions setRowData={setRowData}/>
                            </div>
                        </div>
                    </>
                :
                    <>
                        <div className={[MainStyle.bg_card_item, MainStyle.shadow_sm, MainStyle.border, MainStyle.rounded].join(" ")}>
                            <div className={[MainStyle.d_flex, MainStyle.bg_card_item, MainStyle.rounded_top].join(" ")}>
                                <div className={[ MainStyle.align_self_center]}>
                                    <span className={[MainStyle.mx_3, MainStyle.text_body, MainStyle.fs_5, MainStyle.fw_semibold].join(" ")}>
                                        Filtros
                                    </span> 
                                </div>
                                <div className={[MainStyle.ms_auto].join(" ")}>
                                    <div 
                                        onClick={() => {handleClick();}}
                                        className={[MainStyle.shadow_sm, MainStyle.rounded_top_end_bottom_end_1, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_3, MainStyle.ms_1].join(" ")}>
                                        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div 
                                style={{
                                   height: `${Math.floor(height / 5.0)}rem`,
                                   overflowY: `${overFlow}`,
                                   transition: 'height 0.1s linear',
                                }}
                            >
                            </div>
                        </div>
                    </>
            }
        </>
    );

});

const OrderTableGrid = ({setProps}) => {
    const [ isLoading,      setIsLoading    ]  = useState(false);   // Loading fetch control
    const { showLoader,     hideLoader      }  = useLoader();       // Control over the  
    const [searchText,      setSearchText   ]  = useState('');      // Searched text state
    const [rowData,         setRowData      ]  = useState([]);      // State of rows def 
    const [columnDefs,      setcolumnDefs   ]  = useState([]);      // State of columns def
    const gridRef                              = useRef();
    const { showInfoMessage                 }  = useInfoMsgModal(); // Modal message control 
    const { showFilter,     hideFilter      }  = useFilter();       // Control over the loader    
    const navigate                             = useNavigate();
    const [ reload,         setReload       ]  = useState(true);
    const [ filterMeta,     setFilterMeta   ]  = useState(null);
    const [ searchParam,    setSearchParam  ]  = useState(blank_search_param_obj);

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const EditItem = (props) => {
        const handleData = () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_order_obj));
            obj_copy.ORDER_ID = props.data.ORDER_ID;
            hideFilter();
            setProps({ setScreen: 2, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const ViewItem = (props) => {
        const handleData = async () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_order_obj));
            obj_copy.ORDER_ID = props.data.ORDER_ID;
            hideFilter();
            navigate(`/order/${obj_copy.ORDER_ID}/p`);
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 576 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"/>
                    </svg>
                </div>
            </>
        );
    };

    const CopyItem = (props) => {
        const handleData = async () => {
            showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0) });
            let data = await copyOrder(props.data.ORDER_ID);
            if (data) {
                if (data?.status?.statusCode == 0) {
                    setReload(true);
                }
                else {
                    hideLoader();
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 448 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"/>
                    </svg>
                </div>
            </>
        );
    };

    const ViewDocument = (props) => {
        const handleData = async () => {
            hideFilter();
            navigate(`/order/${props.data.ORDER_ID}/p/d`);
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const defaultCol = [
        {
            headerName: GetLabel(appLang, 571),
            marryChildren: true,
            children: [
                DavidCopperfield(14,89,4) && {
                    //pinned: 'left',
                    headerName: GetLabel(appLang, 115),
                    field: 'editar',
                    cellRenderer: EditItem,
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                    width: 100,
                },
                DavidCopperfield(14,89,2) && {
                    headerName: GetLabel(appLang, 489),
                    field: 'show',
                    cellRenderer: ViewItem,
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                    width: 100,
                },
                DavidCopperfield(14,89,0) && {                  
                    headerName: GetLabel(appLang, 490),
                    field: 'show',
                    cellRenderer: CopyItem,
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                    width: 100,
                },
                DavidCopperfield(14,89,2) &&{
                    columnGroupShow: 'open',
                    headerName: GetLabel(appLang, 491),
                    field: 'show',
                    cellRenderer: ViewDocument,
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                    width: 100,
                },                
            ]
        },
        {
            headerName: GetLabel(appLang, 572),
            marryChildren: true,
            children: [
                { headerName: GetLabel(appLang, 34),     field: "ORDER_ID"     ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 492),    field: "ORDER_CODE"   ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 36),     field: "ORDER_DESC"   ,filter: true , flex: 0, width: 400, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
            ]
        },
        {
            headerName: GetLabel(appLang, 573),
            marryChildren: true,
            children: [
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 318),    field: "SCHOOL_DESC"  ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 319),    field: "AREA_DESC"    ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 321),    field: "PROGRAM_DESC" ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 661),    field: "CLASSES_DESC" ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 322),    field: "CLIENT_DESC"  ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 564),    field: "CLASS"        ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                
            ]
        },
        {
            headerName: GetLabel(appLang, 574),
            marryChildren: true,
            children: [
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 493),    field: "AUTHOR"       ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { columnGroupShow: 'open', headerName: GetLabel(appLang, 117),    field: "CREATED"      ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 38),     field: "OPENING"      ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
                { headerName: GetLabel(appLang, 39),     field: "CLOSING"      ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
            ]
        },     
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!isLoading) {
                setIsLoading(true);
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0) });
                let data = await getOrdersList({STATUS_ID: [3],
                                                SCHOOL_ID: null,
                                                AREA_ID: null,
                                                PROGRAM_ID: null,
                                                CLIENT_ID: null,
                                                DT_INIT: '1970-01-01 00:00:00',
                                                DT_FN: '2050-12-31 23:59:59'});
                if (data) {
                    if (data?.status?.statusCode == 0) {
                        data = data.response.content;
                        setcolumnDefs(defaultCol);
                        let arr = [];
                        for(var j = 0; j < data.length; j++) {
                            arr.push(data[j]);
                        }
                        setRowData(arr);
                        hideLoader();
                        setIsLoading(false);
                        setReload(false);
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                    }
                }
                let metaResponse = await getOrderSearchData();

                if (metaResponse) {
                    if (metaResponse?.status?.statusCode === 0) {
                        setFilterMeta(metaResponse.response.content);
                    }
                }             
            }
        };
        if (reload) {
            fetchData();
        }
        if (filterMeta) {
            showFilter({jsx: <FilterOptions searchParam={searchParam}
                                            setSearchParam={setSearchParam}
                                            setRowData={setRowData}
                                            filterMeta={filterMeta}
            />});
        }
    },[reload, filterMeta, searchParam]);

    return (
        <>
        <DefaultPadding/>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    </>);
};

export const OrderManagementPage = () => {
    const [ screenType,         setScreenType       ]   = useState(1);
    const [ defaultData,        setDefaultData      ]   = useState({});
    const { hideFilter                              }   = useFilter();
    const navigate                                      = useNavigate();       

    const BtnNew = () => {
            hideFilter();
            handleChange({ setScreen: 2, data: blank_order_obj });
    };

    const handleChange = ({ setScreen, data }) => {
        setDefaultData({ ...data });
        setScreenType(setScreen);
    };

    useEffect(() => {
        if (!Heimdall([14])) {
            navigate('/home');
        }
        else {
            SetLastFeature(14);
        }            
    }, [screenType, defaultData]);

    return (
        <>
        {
        screenType == 1? 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 494)}
                </p>
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_10}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(14,89,0) && (
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_blue, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_5].join(" ")}
                                onClick={BtnNew}
                            >
                                {GetLabel(appLang, 120)}
                            </button>
                        </div>
                    )}
                </div>
            </div>            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_12}>
                    <div className={[MainStyle.mx_3, MainStyle.my_2].join(" ")}>
                        <OrderTableGrid setProps={handleChange}/>
                    </div>
                </div>
            </div>
            <div className={MainStyle.pb_3}></div>
        </>
        : screenType == 2?
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 495)}
                </p>
            </div>
            <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                <OrderPanel setProps={handleChange} data={defaultData}/>
            </div>
        </>
        : null
        }
        </>
    );
};